import React, { Component, CSSProperties, ReactNode } from "react";

// NOTE: Deprecated. Each icon will be replaced at some point with a file.

interface CustomIconProps {
  iconName: string;
  color?: string;
  color2?: string;
  increase?: number;
  width?: string | number;
  height?: string | number;
  scale?: number;
  className?: string;
  style?: CSSProperties;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onTouchStart?: (e: React.TouchEvent<HTMLDivElement>) => void;
}

// iconName - color - color2 - increase
class CustomIcon extends Component<CustomIconProps> {
  renderIcon(
    name: string,
    color?: string,
    color2?: string,
    increase?: number,
    width?: string | number,
    height?: string | number
  ): ReactNode {
    switch (name) {
      case "select-arrow": {
        return (
          <svg
            width={width ?? "6"}
            height={height ?? "12"}
            viewBox="0 0 6 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 6L0 12L-5.24537e-07 0L6 6Z"
              fill="var(--color-secondary-placeholder)"
            />
          </svg>
        );
      }

      case "link": {
        return (
          <svg
            width={width ?? "12"}
            height={height ?? "13"}
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_4261_3792)">
              <path
                d="M11.2094 1.4619L10.7916 1.09237C9.81918 0.229856 8.32965 0.319491 7.46755 1.29236L6.27229 2.64068C6.00254 2.9451 6.03044 3.4123 6.33486 3.68247L6.4469 3.78183C6.75217 4.05242 7.2181 4.02451 7.48911 3.71925L8.68395 2.37093C8.95032 2.07032 9.41244 2.04284 9.71306 2.30878L10.1304 2.67873C10.431 2.9451 10.4593 3.4068 10.1925 3.70741L7.57917 6.65562C7.35804 6.9055 6.99612 6.97314 6.69889 6.81967C6.37418 6.65181 5.97801 6.7258 5.73532 6.99894L5.71503 7.02177C5.55098 7.20695 5.48249 7.4526 5.52731 7.69571C5.57212 7.93883 5.72349 8.14389 5.9425 8.25847C6.2892 8.43943 6.66338 8.52737 7.03375 8.52737C7.69037 8.52737 8.33556 8.25212 8.79557 7.73377L11.4085 4.78598C12.2697 3.81438 12.1801 2.32315 11.2085 1.46148L11.2094 1.4619Z"
                fill={color ?? "black"}
              />
              <path
                d="M5.66556 9.31842L5.5531 9.21864C5.24868 8.94889 4.78106 8.97722 4.51131 9.28164L3.31689 10.63C3.0501 10.9301 2.58882 10.958 2.28821 10.6921L1.87048 10.3217C1.56987 10.0554 1.54154 9.59409 1.80833 9.29347L4.42168 6.34569C4.63815 6.10089 4.995 6.03112 5.28842 6.1753C5.62624 6.34104 6.03594 6.26071 6.28624 5.97827L6.29554 5.9677C6.4562 5.78632 6.52385 5.54575 6.48115 5.30771C6.43845 5.06925 6.29173 4.86715 6.07822 4.75299C5.11296 4.23632 3.93165 4.44773 3.20527 5.26754L0.591502 8.21448C-0.269748 9.18608 -0.180114 10.6773 0.791488 11.5386L1.20922 11.9085C1.65654 12.3051 2.21422 12.5 2.76978 12.5C3.42048 12.5 4.06864 12.2324 4.53372 11.7085L5.72856 10.3602C5.99873 10.0549 5.97125 9.58901 5.66556 9.31842Z"
                fill={color ?? "black"}
              />
            </g>
            <defs>
              <clipPath id="clip0_4261_3792">
                <rect
                  width="12.0008"
                  height="12"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        );
      }

      case "lemon-certified-white": {
        return (
          <svg
            width={width ?? "16"}
            height={height ?? "16"}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.8105 5.82554C15.7099 5.38112 15.5674 4.95192 15.3927 4.5322C15.2028 4.0707 15.1477 3.56551 15.2522 3.07554C15.2997 2.85333 15.349 2.63303 15.3946 2.41081C15.4782 2.00817 15.4155 1.58658 15.1838 1.24281C14.9388 0.880072 14.5533 0.636977 14.1184 0.579988C13.8183 0.542003 13.5315 0.617974 13.2409 0.680644C12.8896 0.756611 12.5515 0.823084 12.1888 0.790798C11.6931 0.745217 11.2506 0.500222 10.7834 0.352079C9.93254 0.0861953 9.03041 -0.0296497 8.13971 0.00642916C6.25763 0.0785972 4.44396 0.813576 3.01178 2.03287C1.56651 3.25974 0.535266 4.9671 0.161107 6.82845C-0.0193147 7.72867 -0.0497015 8.65167 0.0775451 9.55949C0.138319 9.99251 0.235179 10.4198 0.37002 10.8357C0.523854 11.3086 0.76505 11.7511 0.795437 12.2563C0.818227 12.6077 0.746057 12.9362 0.67199 13.2781C0.605517 13.5839 0.537148 13.8782 0.590324 14.1935C0.660592 14.6113 0.92458 14.9873 1.28353 15.2095C1.62538 15.4242 2.03181 15.4754 2.42114 15.3919C2.64145 15.3444 2.86177 15.2969 3.08205 15.2494C3.60433 15.1393 4.1133 15.219 4.6014 15.4204C5.42563 15.7622 6.31067 15.9521 7.20137 15.992C9.05119 16.0756 10.9124 15.5001 12.4126 14.4195C12.7963 14.1441 13.1571 13.8384 13.4933 13.5041C13.4952 13.5022 13.499 13.4984 13.5009 13.4965C13.5028 13.4946 13.5066 13.4908 13.5085 13.4889C14.8493 12.1405 15.7229 10.3781 15.9489 8.49018C16.0515 7.60517 16.0059 6.69926 15.8103 5.82561L15.8105 5.82554Z"
              fill="white"
            />
            <path
              d="M11.8817 4.76274C11.9712 4.85193 12.0422 4.9579 12.0907 5.07459C12.1391 5.19128 12.164 5.31639 12.164 5.44274C12.164 5.56909 12.1391 5.69419 12.0907 5.81088C12.0422 5.92757 11.9712 6.03355 11.8817 6.12274L7.40169 10.6027C7.3125 10.6922 7.20653 10.7632 7.08984 10.8117C6.97315 10.8602 6.84804 10.8851 6.72169 10.8851C6.59534 10.8851 6.47024 10.8602 6.35355 10.8117C6.23686 10.7632 6.13088 10.6922 6.04169 10.6027L4.12169 8.68274C4.03239 8.59344 3.96156 8.48743 3.91323 8.37075C3.8649 8.25408 3.84003 8.12902 3.84003 8.00274C3.84003 7.87645 3.8649 7.7514 3.91323 7.63472C3.96156 7.51805 4.03239 7.41204 4.12169 7.32274C4.21099 7.23344 4.317 7.1626 4.43368 7.11427C4.55035 7.06595 4.6754 7.04107 4.80169 7.04107C4.92798 7.04107 5.05303 7.06595 5.1697 7.11427C5.28638 7.1626 5.39239 7.23344 5.48169 7.32274L6.72249 8.56194L10.5233 4.76034C10.6126 4.67124 10.7186 4.60062 10.8352 4.55251C10.9519 4.5044 11.0768 4.47976 11.203 4.47998C11.3291 4.4802 11.454 4.50529 11.5705 4.55381C11.6869 4.60233 11.7927 4.67332 11.8817 4.76274Z"
              fill="var(--color-secondary-bluegrey-7)"
            />
          </svg>
        );
      }

      case "video-player": {
        return (
          <svg
            width={width ?? "23"}
            height={height ?? "20"}
            viewBox="0 0 23 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.1611 7.55363L9.97932 4.09908C9.84922 4.01228 9.698 3.96244 9.54179 3.95487C9.38558 3.94731 9.23025 3.9823 9.09238 4.05611C8.9545 4.12993 8.83926 4.23979 8.75894 4.37399C8.67863 4.50818 8.63626 4.66167 8.63636 4.81806V11.7272C8.63626 11.8835 8.67863 12.037 8.75894 12.1712C8.83926 12.3054 8.9545 12.4153 9.09238 12.4891C9.23025 12.5629 9.38558 12.5979 9.54179 12.5903C9.698 12.5828 9.84922 12.5329 9.97932 12.4461L15.1611 8.99158C15.2796 8.91275 15.3767 8.80586 15.4439 8.68043C15.5111 8.555 15.5463 8.4149 15.5463 8.27261C15.5463 8.13031 15.5111 7.99022 15.4439 7.86478C15.3767 7.73935 15.2796 7.63246 15.1611 7.55363ZM10.3636 10.1132V6.43738L13.1251 8.27261L10.3636 10.1132ZM20.7273 0.499878H1.72727C1.26917 0.499878 0.829833 0.681858 0.505906 1.00578C0.18198 1.32971 0 1.76905 0 2.22715V14.3181C0 14.7762 0.18198 15.2155 0.505906 15.5394C0.829833 15.8634 1.26917 16.0453 1.72727 16.0453H20.7273C21.1854 16.0453 21.6247 15.8634 21.9486 15.5394C22.2726 15.2155 22.4545 14.7762 22.4545 14.3181V2.22715C22.4545 1.76905 22.2726 1.32971 21.9486 1.00578C21.6247 0.681858 21.1854 0.499878 20.7273 0.499878ZM20.7273 14.3181H1.72727V2.22715H20.7273V14.3181ZM22.4545 18.6362C22.4545 18.8653 22.3636 19.085 22.2016 19.2469C22.0396 19.4089 21.82 19.4999 21.5909 19.4999H0.863636C0.634586 19.4999 0.414916 19.4089 0.252953 19.2469C0.09099 19.085 0 18.8653 0 18.6362C0 18.4072 0.09099 18.1875 0.252953 18.0256C0.414916 17.8636 0.634586 17.7726 0.863636 17.7726H21.5909C21.82 17.7726 22.0396 17.8636 22.2016 18.0256C22.3636 18.1875 22.4545 18.4072 22.4545 18.6362Z"
              fill="black"
            />
          </svg>
        );
      }

      case "plus": {
        return (
          <svg
            width={width ?? "16"}
            height={height ?? "16"}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="7" width="2" height="16" fill={color ?? "white"} />
            <rect y="7" width="16" height="2" fill={color ?? "white"} />
          </svg>
        );
      }

      case "close_alt": {
        return (
          <svg
            width={width ?? "30"}
            height={height ?? "30"}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="15"
              cy="15"
              r="15"
              fill={color ?? "var(--color-secondary-bluegrey-6)"}
            />
            <path
              d="M16.8358 14.9689L20.9262 10.8783C21.0244 10.7801 21.0244 10.6209 20.9262 10.5227L19.415 9.01118C19.3679 8.96403 19.3038 8.9375 19.2373 8.9375C19.1706 8.9375 19.1066 8.96403 19.0595 9.01118L14.9688 13.1019L10.878 9.01118C10.7837 8.91688 10.6168 8.91688 10.5225 9.01118L9.01115 10.5227C8.91295 10.6209 8.91295 10.7801 9.01115 10.8783L13.1017 14.9689L9.01115 19.0595C8.91295 19.1577 8.91295 19.3169 9.01115 19.4151L10.5225 20.9265C10.5696 20.9737 10.6336 21.0002 10.7002 21.0002C10.7669 21.0002 10.8309 20.9737 10.878 20.9265L14.9688 16.8358L19.0595 20.9265C19.1066 20.9737 19.1706 21.0002 19.2373 21.0002C19.3038 21.0002 19.3679 20.9737 19.415 20.9265L20.9264 19.4151C21.0245 19.3169 21.0245 19.1576 20.9264 19.0595L16.8358 14.9689Z"
              fill={color2 ?? "white"}
            />
          </svg>
        );
      }

      case "haptic": {
        return (
          <svg
            width={width ?? "19"}
            height={height ?? "15"}
            viewBox="0 0 19 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.75 1.875V13.125C13.75 13.6223 13.5525 14.0992 13.2008 14.4508C12.8492 14.8025 12.3723 15 11.875 15H6.875C6.37772 15 5.90081 14.8025 5.54917 14.4508C5.19754 14.0992 5 13.6223 5 13.125V1.875C5 1.37772 5.19754 0.900806 5.54917 0.549175C5.90081 0.197544 6.37772 0 6.875 0H11.875C12.3723 0 12.8492 0.197544 13.2008 0.549175C13.5525 0.900806 13.75 1.37772 13.75 1.875ZM15.625 3.75C15.4592 3.75 15.3003 3.81585 15.1831 3.93306C15.0658 4.05027 15 4.20924 15 4.375V10.625C15 10.7908 15.0658 10.9497 15.1831 11.0669C15.3003 11.1842 15.4592 11.25 15.625 11.25C15.7908 11.25 15.9497 11.1842 16.0669 11.0669C16.1842 10.9497 16.25 10.7908 16.25 10.625V4.375C16.25 4.20924 16.1842 4.05027 16.0669 3.93306C15.9497 3.81585 15.7908 3.75 15.625 3.75ZM18.125 5C17.9592 5 17.8003 5.06585 17.6831 5.18306C17.5658 5.30027 17.5 5.45924 17.5 5.625V9.375C17.5 9.54076 17.5658 9.69973 17.6831 9.81694C17.8003 9.93415 17.9592 10 18.125 10C18.2908 10 18.4497 9.93415 18.5669 9.81694C18.6842 9.69973 18.75 9.54076 18.75 9.375V5.625C18.75 5.45924 18.6842 5.30027 18.5669 5.18306C18.4497 5.06585 18.2908 5 18.125 5ZM3.125 3.75C2.95924 3.75 2.80027 3.81585 2.68306 3.93306C2.56585 4.05027 2.5 4.20924 2.5 4.375V10.625C2.5 10.7908 2.56585 10.9497 2.68306 11.0669C2.80027 11.1842 2.95924 11.25 3.125 11.25C3.29076 11.25 3.44973 11.1842 3.56694 11.0669C3.68415 10.9497 3.75 10.7908 3.75 10.625V4.375C3.75 4.20924 3.68415 4.05027 3.56694 3.93306C3.44973 3.81585 3.29076 3.75 3.125 3.75ZM0.625 5C0.45924 5 0.300268 5.06585 0.183058 5.18306C0.065848 5.30027 0 5.45924 0 5.625V9.375C0 9.54076 0.065848 9.69973 0.183058 9.81694C0.300268 9.93415 0.45924 10 0.625 10C0.79076 10 0.949732 9.93415 1.06694 9.81694C1.18415 9.69973 1.25 9.54076 1.25 9.375V5.625C1.25 5.45924 1.18415 5.30027 1.06694 5.18306C0.949732 5.06585 0.79076 5 0.625 5Z"
              fill="var(--color-primary-black)"
            />
          </svg>
        );
      }

      case "volume": {
        return (
          <svg
            width={width ?? "19"}
            height={height ?? "17"}
            viewBox="0 0 19 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.8992 0.0631549C10.7941 0.0119402 10.6768 -0.00876703 10.5605 0.00338606C10.4442 0.0155391 10.3336 0.0600653 10.2414 0.131905L4.78516 4.37487H1.25C0.918479 4.37487 0.600537 4.50657 0.366116 4.74099C0.131696 4.97541 0 5.29335 0 5.62487V10.6249C0 10.9564 0.131696 11.2743 0.366116 11.5088C0.600537 11.7432 0.918479 11.8749 1.25 11.8749H4.78516L10.2414 16.1178C10.3337 16.1896 10.4444 16.2341 10.5607 16.2461C10.677 16.2581 10.7944 16.2373 10.8995 16.1859C11.0045 16.1346 11.0931 16.0548 11.155 15.9556C11.217 15.8564 11.2499 15.7418 11.25 15.6249V0.624874C11.25 0.507786 11.2171 0.393048 11.1551 0.293735C11.0931 0.194422 11.0044 0.114527 10.8992 0.0631549ZM4.375 10.6249H1.25V5.62487H4.375V10.6249ZM14.2188 6.05925C14.7215 6.62993 14.9988 7.36435 14.9988 8.12487C14.9988 8.8854 14.7215 9.61981 14.2188 10.1905C14.1083 10.3118 13.9546 10.3849 13.7908 10.3939C13.627 10.4029 13.4662 10.3471 13.3432 10.2386C13.2201 10.1301 13.1447 9.97761 13.1331 9.81397C13.1215 9.65033 13.1747 9.48869 13.2812 9.36394C13.5827 9.02157 13.749 8.58104 13.749 8.12487C13.749 7.6687 13.5827 7.22818 13.2812 6.88581C13.1747 6.76106 13.1215 6.59942 13.1331 6.43578C13.1447 6.27213 13.2201 6.11961 13.3432 6.01111C13.4662 5.90262 13.627 5.84686 13.7908 5.85586C13.9546 5.86487 14.1083 5.93792 14.2188 6.05925ZM18.125 8.12487C18.1259 9.66253 17.5592 11.1464 16.5336 12.2921C16.4223 12.4125 16.268 12.4844 16.1042 12.4922C15.9403 12.4999 15.78 12.443 15.6577 12.3335C15.5355 12.2241 15.4612 12.0711 15.4508 11.9074C15.4405 11.7436 15.4949 11.5824 15.6023 11.4585C16.4222 10.5418 16.8754 9.35509 16.8754 8.12527C16.8754 6.89544 16.4222 5.70875 15.6023 4.79206C15.5461 4.73117 15.5025 4.65969 15.4741 4.58179C15.4457 4.50388 15.4331 4.42111 15.437 4.33829C15.441 4.25547 15.4613 4.17426 15.4969 4.09939C15.5326 4.02451 15.5827 3.95748 15.6445 3.90218C15.7063 3.84688 15.7784 3.80442 15.8568 3.77729C15.9351 3.75015 16.0181 3.73887 16.1008 3.74411C16.1836 3.74935 16.2645 3.771 16.3388 3.8078C16.4131 3.8446 16.4793 3.89582 16.5336 3.95847C17.5595 5.10364 18.1262 6.58739 18.125 8.12487Z"
              fill="var(--color-primary-black)"
            />
          </svg>
        );
      }

      case "user-circle": {
        return (
          <svg
            width={width ?? "32"}
            height={height ?? "32"}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="var(--color-primary-black)" />
            <path
              d="M16.2706 17.5002C14.3882 17.5002 11 18.3252 11 20.1251V22.0001H21.5412V20.1251C21.5412 18.3252 18.1529 17.5002 16.2706 17.5002Z"
              fill="white"
            />
            <path
              d="M16.2706 15.9998C17.9339 15.9998 19.2823 14.6567 19.2823 12.9999C19.2823 11.3431 17.9339 10 16.2706 10C14.6072 10 13.2588 11.3431 13.2588 12.9999C13.2588 14.6567 14.6072 15.9998 16.2706 15.9998Z"
              fill="white"
            />
          </svg>
        );
      }

      case "message": {
        return (
          <svg
            width={width ?? "21"}
            height={height ?? "21"}
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.14 6.43126C19.6142 5.17625 18.8492 4.03552 17.8877 3.07267C16.9291 2.10815 15.7903 1.34129 14.5361 0.815646C13.2513 0.274548 11.8709 -0.00281801 10.4768 2.15843e-05H10.4299C9.01192 0.00705283 7.64083 0.288303 6.34942 0.841427C5.10599 1.37246 3.97795 2.14068 3.02833 3.10314C2.07614 4.06383 1.31991 5.20056 0.801769 6.45002C0.263915 7.7493 -0.0086187 9.14304 0.00020773 10.5492C0.00723897 12.1758 0.396301 13.7906 1.12286 15.2344V18.7969C1.12286 19.3922 1.60568 19.875 2.19864 19.875H5.75645C7.20694 20.6069 8.80756 20.992 10.4322 21H10.4814C11.883 21 13.24 20.7281 14.5197 20.1961C15.7676 19.6767 16.9021 18.9188 17.8596 17.9648C18.8252 17.0063 19.5846 15.8859 20.1166 14.6367C20.6674 13.343 20.9486 11.9672 20.9557 10.5469C20.9603 9.11954 20.6838 7.73439 20.14 6.43126ZM5.79864 11.625C5.17989 11.625 4.67598 11.1211 4.67598 10.5C4.67598 9.87892 5.17989 9.37501 5.79864 9.37501C6.41739 9.37501 6.92129 9.87892 6.92129 10.5C6.92129 11.1211 6.41973 11.625 5.79864 11.625ZM10.4768 11.625C9.85801 11.625 9.35411 11.1211 9.35411 10.5C9.35411 9.87892 9.85801 9.37501 10.4768 9.37501C11.0955 9.37501 11.5994 9.87892 11.5994 10.5C11.5994 11.1211 11.0955 11.625 10.4768 11.625ZM15.1549 11.625C14.5361 11.625 14.0322 11.1211 14.0322 10.5C14.0322 9.87892 14.5361 9.37501 15.1549 9.37501C15.7736 9.37501 16.2775 9.87892 16.2775 10.5C16.2775 11.1211 15.7736 11.625 15.1549 11.625Z"
              fill={color}
            />
          </svg>
        );
      }

      case "times": {
        return (
          <svg
            width={width ?? "14"}
            height={height ?? "14"}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.1818 1.69497L11.8588 0.371948L6.61359 5.61711L1.36843 0.371948L0.0454102 1.69497L5.29057 6.94013L0.0454102 12.1853L1.36843 13.5083L6.61359 8.26315L11.8588 13.5083L13.1818 12.1853L7.93661 6.94013L13.1818 1.69497Z"
              fill={color ?? "var(--color-primary-black)"}
            />
          </svg>
        );
      }

      case "times-radio": {
        return (
          <svg
            width={width ?? "26"}
            height={height ?? "26"}
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="26"
              height="26"
              rx="13"
              fill={color ?? "var(--color-secondary-orange-3)"}
            />
            <path
              d="M14.5674 13.0151L17.9687 9.61377C18.0503 9.53212 18.0503 9.39976 17.9687 9.31811L16.7121 8.06126C16.6729 8.02206 16.6196 8 16.5643 8C16.5089 8 16.4556 8.02206 16.4164 8.06126L13.015 11.4627L9.61356 8.06126C9.53515 7.98285 9.39631 7.98285 9.3179 8.06126L8.06124 9.31811C7.97959 9.39976 7.97959 9.53212 8.06124 9.61377L11.4626 13.0151L8.06124 16.4163C7.97959 16.498 7.97959 16.6303 8.06124 16.712L9.3179 17.9687C9.3571 18.0079 9.41032 18.03 9.46573 18.03C9.52114 18.03 9.57435 18.0079 9.61356 17.9687L13.015 14.5673L16.4164 17.9687C16.4556 18.0079 16.5089 18.03 16.5643 18.03C16.6196 18.03 16.6729 18.0079 16.7121 17.9687L17.9688 16.712C18.0504 16.6303 18.0504 16.4979 17.9688 16.4163L14.5674 13.0151Z"
              fill="white"
            />
          </svg>
        );
      }

      case "like": {
        return (
          <svg
            style={{
              marginInlineStart: "5px",
              marginTop: "-5px",
            }}
            width={width ?? "26"}
            height={height ?? "29"}
            viewBox="0 0 26 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.6251 5.50253C17.6251 2.45003 16.2001 0.253784 13.8663 0.253784C12.5838 0.253784 12.1438 1.00628 11.6838 2.75378C11.5901 3.11503 11.5438 3.29128 11.4951 3.46378C11.3688 3.91253 11.1488 4.67628 10.8363 5.75253C10.8278 5.78128 10.8152 5.80864 10.7988 5.83378L7.21758 11.4413C6.36967 12.7673 5.11882 13.7864 3.64883 14.3488L3.05758 14.575C2.30264 14.8642 1.67376 15.4102 1.28147 16.117C0.889171 16.8239 0.758558 17.6464 0.91258 18.44L1.41758 21.0475C1.56536 21.8098 1.92847 22.5137 2.46392 23.0759C2.99937 23.6382 3.68472 24.0352 4.43883 24.22L13.9738 26.5575C15.4939 26.9299 17.0996 26.6871 18.4416 25.8819C19.7836 25.0766 20.7534 23.7741 21.1401 22.2575L22.9088 15.32C23.0616 14.7203 23.0752 14.0935 22.9488 13.4876C22.8224 12.8818 22.5592 12.3128 22.1793 11.8242C21.7994 11.3355 21.313 10.9401 20.757 10.6682C20.201 10.3963 19.5902 10.2549 18.9713 10.255H16.6938C17.3138 8.21378 17.6263 6.63878 17.6263 5.50253H17.6251ZM2.75008 18.0838C2.67989 17.7229 2.73918 17.3489 2.91751 17.0275C3.09584 16.706 3.38179 16.4577 3.72508 16.3263L4.31758 16.1013C6.16213 15.395 7.7315 14.1156 8.79508 12.4513L12.3788 6.84378C12.4913 6.66753 12.5776 6.47628 12.6351 6.27503C12.9501 5.19378 13.1701 4.42628 13.2976 3.97128C13.3526 3.78003 13.4038 3.58628 13.4963 3.23128C13.7338 2.32878 13.8501 2.12878 13.8651 2.12878C14.9501 2.12878 15.7488 3.35878 15.7488 5.50378C15.7488 6.60878 15.3413 8.42253 14.5188 10.8963C14.4719 11.0371 14.4591 11.1871 14.4815 11.3339C14.5039 11.4807 14.5608 11.62 14.6476 11.7405C14.7344 11.861 14.8485 11.9591 14.9807 12.0268C15.1128 12.0945 15.2591 12.1299 15.4076 12.13H18.9701C19.3033 12.1302 19.632 12.2065 19.9312 12.3531C20.2305 12.4996 20.4923 12.7125 20.6968 12.9756C20.9013 13.2386 21.043 13.5449 21.1111 13.8711C21.1793 14.1972 21.1721 14.5346 21.0901 14.8575L19.3213 21.795C19.0566 22.8326 18.3929 23.7237 17.4746 24.2745C16.5563 24.8253 15.4576 24.9913 14.4176 24.7363L4.88258 22.3988C4.47673 22.2992 4.10789 22.0855 3.81969 21.7829C3.53149 21.4803 3.33599 21.1015 3.25633 20.6913L2.75008 18.0838Z"
              fill={color}
            />
          </svg>
        );
      }

      case "save": {
        return (
          <svg
            width={width ?? "18"}
            height={height ?? "26"}
            viewBox="0 0 20 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.915033 27.8309C0.359477 27.5604 0 26.9517 0 26.3092V2.70531C0 1.21739 1.17647 0 2.61438 0H17.3856C18.8235 0 20 1.21739 20 2.70531V26.2754C20 26.9179 19.6405 27.5266 19.085 27.7971C18.8562 27.9324 18.5948 28 18.366 28C18.0065 28 17.6471 27.8647 17.3529 27.628L17.3203 27.5942L10 21.2029L2.67974 27.5942L2.64706 27.628C2.15686 28.0338 1.50327 28.1014 0.915033 27.8309ZM18 25.5326L10 18.5479L2 25.5326V2.70531C2 2.25695 2.34495 2 2.61438 2H17.3856C17.6551 2 18 2.25696 18 2.70531V25.5326Z"
              fill={color ?? "var(--color-primary-black)"}
            />
          </svg>
        );
      }

      case "save.fill": {
        // return <img src={Unsave} alt="" />;
        return (
          <svg
            width={width ?? "18"}
            height={height ?? "26"}
            viewBox="0 0 20 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.915033 27.8309C0.359477 27.5604 0 26.9517 0 26.3092V2.70531C0 1.21739 1.17647 0 2.61438 0H17.3856C18.8235 0 20 1.21739 20 2.70531V26.2754C20 26.9179 19.6405 27.5266 19.085 27.7971C18.8562 27.9324 18.5948 28 18.366 28C18.0065 28 17.6471 27.8647 17.3529 27.628L17.3203 27.5942L10 21.2029L2.67974 27.5942L2.64706 27.628C2.15686 28.0338 1.50327 28.1014 0.915033 27.8309Z"
              fill={color ?? "url(#paint0_linear_4473_16903)"}
            />
            <defs>
              <linearGradient
                id="paint0_linear_4473_16903"
                x1="10"
                y1="0"
                x2="10"
                y2="28"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF699C" />
                <stop offset="1" stopColor="#FE5763" />
              </linearGradient>
            </defs>
          </svg>
        );
      }

      case "search": {
        return (
          <svg
            width={width ?? "21"}
            height={height ?? "21"}
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.3 8.2C10.7 7.4 11 6.5 11 5.5C11 2.5 8.5 0 5.5 0C2.5 0 0 2.5 0 5.5C0 8.5 2.5 11 5.5 11C6.5 11 7.4 10.7 8.2 10.3L11.5 13.6C11.8 13.9 12.2 14 12.6 14C13 14 13.4 13.9 13.7 13.6C14.3 13 14.3 12.1 13.7 11.5L10.3 8.2ZM5.5 9.3C3.4 9.3 1.7 7.6 1.7 5.5C1.7 3.4 3.4 1.7 5.5 1.7C7.6 1.7 9.3 3.4 9.3 5.5C9.3 7.6 7.6 9.3 5.5 9.3Z"
              fill={color ?? "var(--color-primary-black)"}
            />
          </svg>
        );
      }

      case "user": {
        return (
          <svg
            width={width ?? "21"}
            height={height ?? "21"}
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 10C4.5 10 0 11.1 0 13.5V16H14V13.5C14 11.1 9.5 10 7 10Z"
              fill={color}
            />
            <path
              d="M7 8C9.20914 8 11 6.20914 11 4C11 1.79086 9.20914 0 7 0C4.79086 0 3 1.79086 3 4C3 6.20914 4.79086 8 7 8Z"
              fill={color}
            />
          </svg>
        );
      }

      case "author": {
        return (
          <svg
            width={width ?? "24"}
            height={height ?? "25"}
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.3113 7.37821L17.1216 3.18946C16.9823 3.05014 16.8169 2.93962 16.6349 2.86421C16.4529 2.78881 16.2578 2.75 16.0608 2.75C15.8638 2.75 15.6687 2.78881 15.4867 2.86421C15.3047 2.93962 15.1393 3.05014 15 3.18946L3.4397 14.7498C3.2998 14.8886 3.18889 15.0538 3.11341 15.2358C3.03792 15.4178 2.99938 15.613 3.00001 15.8101V19.9998C3.00001 20.3976 3.15804 20.7791 3.43935 21.0604C3.72065 21.3417 4.10218 21.4998 4.50001 21.4998H20.25C20.4489 21.4998 20.6397 21.4208 20.7803 21.2801C20.921 21.1395 21 20.9487 21 20.7498C21 20.5509 20.921 20.3601 20.7803 20.2194C20.6397 20.0788 20.4489 19.9998 20.25 19.9998H10.8113L21.3113 9.49977C21.4506 9.36048 21.5611 9.19511 21.6365 9.0131C21.7119 8.83108 21.7507 8.636 21.7507 8.43899C21.7507 8.24198 21.7119 8.0469 21.6365 7.86489C21.5611 7.68288 21.4506 7.5175 21.3113 7.37821ZM12.75 7.56009L14.3147 9.12477L6.37501 17.0645L4.81032 15.4998L12.75 7.56009ZM4.50001 19.9998V17.3101L7.1897 19.9998H4.50001ZM9.00001 19.6895L7.43626 18.1248L15.375 10.1851L16.9397 11.7498L9.00001 19.6895ZM18 10.6895L13.8113 6.49977L16.0613 4.24977L20.25 8.43946L18 10.6895Z"
              fill="var(--color-primary-black)"
            />
          </svg>
        );
      }

      case "marker": {
        return (
          <svg
            width={width ?? "11"}
            height={height ?? "20"}
            viewBox="0 0 15 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.0392 0H1.96078C0.882353 0 0 1.11176 0 2.47059V24.0265C0 24.6132 0.269608 25.1691 0.686275 25.4162C1.12745 25.6632 1.61765 25.6015 1.98529 25.2309L2.0098 25.2L7.5 19.3632L12.9902 25.2L13.0147 25.2309C13.2353 25.4471 13.5049 25.5706 13.7745 25.5706C13.9461 25.5706 14.1422 25.5088 14.3137 25.3853C14.7304 25.1382 15 24.5824 15 23.9956V2.47059C15 1.11176 14.1176 0 13.0392 0Z"
              fill={color}
            />
          </svg>
        );
      }

      case "play": {
        return (
          <svg
            width={width ?? "20"}
            height={height ?? "24"}
            viewBox="0 0 14 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.1808 16.3584L12.9308 9.63967C13.3235 9.39368 13.5624 8.96318 13.5624 8.50001C13.5624 8.03683 13.3235 7.60641 12.9308 7.36034L2.1808 0.641588C1.76651 0.382412 1.24421 0.367966 0.817062 0.606146C0.389918 0.842982 0.124863 1.29247 0.124863 1.78126V15.2188C0.124863 15.7075 0.389918 16.157 0.817062 16.3939C1.02014 16.5067 1.24454 16.5625 1.46861 16.5625C1.71595 16.5625 1.96328 16.4942 2.1808 16.3584Z"
              fill={color ?? "white"}
            />
          </svg>
        );
      }

      case "play_circle": {
        return (
          <svg
            width={width ?? "80"}
            height={height ?? "80"}
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="40"
              cy="40"
              r="40"
              fill="var(--color-primary-black)"
              fillOpacity="0.95"
            />
            <path
              d="M53.8929 38.097C55.2543 38.8611 55.2543 40.8209 53.8929 41.585L32.9789 53.3243C31.6458 54.0726 30 53.1091 30 51.5803L30 28.1017C30 26.5728 31.6458 25.6093 32.9789 26.3577L53.8929 38.097Z"
              fill="white"
            />
          </svg>
        );
      }

      case "pause": {
        return (
          <svg
            style={{ marginInlineEnd: "6px" }}
            width={width ?? "18"}
            height={height ?? "18"}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="7" height="16" rx="1" fill={color} />
            <rect x="9" width="7" height="16" rx="1" fill={color} />
          </svg>
        );
      }

      case "send_message": {
        return (
          <svg
            width={width ?? "24"}
            height={height ?? "23"}
            viewBox="0 0 24 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.79029 0.122798L22.8603 10.2008C23.073 10.3026 23.2525 10.4625 23.3782 10.662C23.5039 10.8615 23.5706 11.0925 23.5706 11.3283C23.5706 11.5641 23.5039 11.7951 23.3782 11.9946C23.2525 12.1941 23.073 12.354 22.8603 12.4558L1.79029 22.5338C1.5742 22.6374 1.3329 22.6767 1.09512 22.647C0.85734 22.6173 0.633104 22.5199 0.449121 22.3663C0.265138 22.2128 0.129162 22.0096 0.0573883 21.781C-0.0143853 21.5524 -0.0189315 21.3079 0.0442913 21.0768L2.15229 13.3488C2.1781 13.2541 2.23121 13.1691 2.30501 13.1043C2.3788 13.0396 2.47002 12.998 2.56729 12.9848L12.7773 11.5978C12.8199 11.5918 12.8602 11.575 12.8943 11.5489C12.9285 11.5228 12.9553 11.4883 12.9723 11.4488L12.9903 11.3858C12.9982 11.33 12.987 11.2731 12.9585 11.2245C12.93 11.1758 12.8858 11.1382 12.8333 11.1178L12.7783 11.1028L2.57829 9.7168C2.4812 9.70338 2.3902 9.66172 2.3166 9.59701C2.24299 9.53229 2.19003 9.44737 2.16429 9.3528L0.0442913 1.5798C-0.0189315 1.34866 -0.0143853 1.10422 0.0573883 0.875598C0.129162 0.646972 0.265138 0.443795 0.449121 0.290265C0.633104 0.136735 0.85734 0.0393237 1.09512 0.009633C1.3329 -0.0200577 1.5742 0.0192236 1.79029 0.122798Z"
              fill={color ?? "var(--color-secondary-bluegrey-6)"}
            />
          </svg>
        );
      }

      case "eye": {
        return (
          <svg
            width={width ?? "58"}
            height={height ?? "33"}
            viewBox="0 0 58 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M36.25 16.5C36.25 20.3987 32.9972 23.5714 29 23.5714C25.0028 23.5714 21.75 20.3987 21.75 16.5C21.75 12.6013 25.0028 9.42857 29 9.42857C32.9972 9.42857 36.25 12.6013 36.25 16.5ZM58 15.4416C58 15.4416 47.7243 33 29.0363 33C11.6846 33 0 15.4416 0 15.4416C0 15.4416 10.7445 0 29.0363 0C47.6301 0 58 15.4416 58 15.4416ZM41.0833 16.5C41.0833 9.99193 35.6748 4.71429 29 4.71429C22.3276 4.71429 16.9167 9.99193 16.9167 16.5C16.9167 23.0104 22.3276 28.2857 29 28.2857C35.6748 28.2857 41.0833 23.0104 41.0833 16.5Z"
              fill={color}
            />
          </svg>
        );
      }

      case "share-alt": {
        return (
          <svg
            width={width ?? "30"}
            height={height ?? "30"}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.293 16.2929L28.293 0.292877L29.7072 1.70709L13.7072 17.7071L12.293 16.2929Z"
              fill="var(--color-primary-black)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29.7071 0.292891C29.9788 0.564529 30.0708 0.967761 29.9439 1.33035L20.1439 29.3303C20.0084 29.7173 19.6504 29.9825 19.2408 29.9992C18.8311 30.0159 18.4527 29.7808 18.2862 29.4061L12.8424 17.1576L0.593867 11.7138C0.219186 11.5473 -0.0158775 11.1689 0.000836285 10.7592C0.0175501 10.3496 0.282654 9.99159 0.669655 9.85614L28.6697 0.056139C29.0322 -0.0707664 29.4355 0.0212527 29.7071 0.292891ZM3.71108 10.9106L14.0061 15.4862C14.2324 15.5867 14.4133 15.7676 14.5138 15.9939L19.0894 26.2889L27.37 2.62997L3.71108 10.9106Z"
              fill="var(--color-primary-black)"
            />
          </svg>
        );
      }

      case "share": {
        return (
          <svg
            width={width ?? "15"}
            height={height ?? "16"}
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.1668 2.66664C14.1668 3.8633 13.1968 4.8334 12.0001 4.8334C10.8035 4.8334 9.8335 3.8633 9.8335 2.66664C9.8335 1.4701 10.8035 0.5 12.0001 0.5C13.1968 0.5 14.1668 1.4701 14.1668 2.66664Z"
              fill={color}
            />
            <path
              d="M12.0001 5.33341C10.5294 5.33341 9.3335 4.13736 9.3335 2.66664C9.3335 1.19605 10.5294 0 12.0001 0C13.4709 0 14.6668 1.19605 14.6668 2.66664C14.6668 4.13736 13.4709 5.33341 12.0001 5.33341ZM12.0001 1.00001C11.0808 1.00001 10.3335 1.74806 10.3335 2.66664C10.3335 3.58535 11.0808 4.3334 12.0001 4.3334C12.9195 4.3334 13.6668 3.58535 13.6668 2.66664C13.6668 1.74806 12.9195 1.00001 12.0001 1.00001Z"
              fill={color}
            />
            <path
              d="M14.1668 13.3338C14.1668 14.5303 13.1968 15.5004 12.0001 15.5004C10.8035 15.5004 9.8335 14.5303 9.8335 13.3338C9.8335 12.1371 10.8035 11.167 12.0001 11.167C13.1968 11.167 14.1668 12.1371 14.1668 13.3338Z"
              fill={color}
            />
            <path
              d="M12.0001 16.0004C10.5294 16.0004 9.3335 14.8043 9.3335 13.3338C9.3335 11.863 10.5294 10.667 12.0001 10.667C13.4709 10.667 14.6668 11.863 14.6668 13.3338C14.6668 14.8043 13.4709 16.0004 12.0001 16.0004ZM12.0001 11.667C11.0808 11.667 10.3335 12.4151 10.3335 13.3338C10.3335 14.2523 11.0808 15.0004 12.0001 15.0004C12.9195 15.0004 13.6668 14.2523 13.6668 13.3338C13.6668 12.4151 12.9195 11.667 12.0001 11.667Z"
              fill={color}
            />
            <path
              d="M4.8334 8.00062C4.8334 9.19729 3.8633 10.1673 2.66664 10.1673C1.4701 10.1673 0.5 9.19729 0.5 8.00062C0.5 6.80396 1.4701 5.83398 2.66664 5.83398C3.8633 5.83398 4.8334 6.80396 4.8334 8.00062Z"
              fill={color}
            />
            <path
              d="M2.66664 10.6673C1.19605 10.6673 0 9.47134 0 8.00063C0 6.52992 1.19605 5.33398 2.66664 5.33398C4.13736 5.33398 5.33341 6.52992 5.33341 8.00063C5.33341 9.47134 4.13736 10.6673 2.66664 10.6673ZM2.66664 6.33399C1.74733 6.33399 1.00001 7.08192 1.00001 8.00063C1.00001 8.91934 1.74733 9.66727 2.66664 9.66727C3.58608 9.66727 4.3334 8.91934 4.3334 8.00063C4.3334 7.08192 3.58608 6.33399 2.66664 6.33399Z"
              fill={color}
            />
            <path
              d="M4.24082 7.68119C4.00877 7.68119 3.78342 7.56046 3.66074 7.34452C3.47873 7.02518 3.59079 6.61783 3.91013 6.43509L10.0961 2.90846C10.4154 2.7251 10.8228 2.83717 11.0055 3.15772C11.1875 3.47706 11.0755 3.88441 10.7561 4.06715L4.57005 7.59379C4.46604 7.65312 4.35276 7.68119 4.24082 7.68119Z"
              fill={color}
            />
            <path
              d="M10.426 13.1811C10.3139 13.1811 10.2006 13.153 10.0966 13.0937L3.91053 9.56702C3.59119 9.38502 3.47925 8.97766 3.66126 8.65759C3.84253 8.33764 4.2505 8.22497 4.57057 8.40832L10.7566 11.935C11.076 12.117 11.1879 12.5243 11.0059 12.8444C10.8826 13.0603 10.6573 13.1811 10.426 13.1811Z"
              fill={color}
            />
          </svg>
        );
      }

      case "trash": {
        return (
          <svg
            width={increase ? "15" : "20"}
            height={increase ? "18" : "23"}
            viewBox="0 0 15 18"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.50219 1.08668H6.49387V1.59293H5.40754V1.01566C5.40719 0.455625 5.86281 0 6.4225 0H9.57355C10.1332 0 10.5889 0.455625 10.5889 1.01566V1.59258H9.50219V1.08668Z"
              fill={color}
            />
            <path
              d="M2.89883 5.89746H13.098C13.3775 5.89746 13.5976 6.13582 13.5751 6.41461L12.7225 16.9583C12.6747 17.5468 12.1839 18 11.594 18H4.40316C3.81324 18 3.32246 17.5468 3.275 16.958L2.42246 6.41461C2.39926 6.13582 2.61933 5.89746 2.89883 5.89746ZM10.6283 16.8754C10.6395 16.8761 10.6511 16.8764 10.6624 16.8764C10.9471 16.8764 11.1862 16.6546 11.2041 16.3666L11.7385 7.71082C11.7568 7.41129 11.529 7.15359 11.2298 7.13496C10.9313 7.11668 10.6726 7.34414 10.6539 7.64367L10.1196 16.2995C10.1013 16.5994 10.3291 16.8567 10.6283 16.8754ZM7.4491 16.3332C7.4491 16.6331 7.69238 16.8764 7.99226 16.8764C8.29215 16.8764 8.53543 16.6331 8.53543 16.3332V7.67742C8.53543 7.37719 8.29215 7.13426 7.99226 7.13426C7.69238 7.13426 7.4491 7.37754 7.4491 7.67742V16.3332ZM4.25832 7.70941L4.76844 16.3652C4.78531 16.6539 5.02472 16.8764 5.31019 16.8764C5.32074 16.8764 5.33164 16.8761 5.34254 16.8757C5.64207 16.8581 5.87058 16.6008 5.85301 16.3012L5.34289 7.64543C5.32531 7.3459 5.06902 7.11738 4.76879 7.13496C4.46926 7.15254 4.24074 7.40988 4.25832 7.70941Z"
              fill={color}
            />
            <path
              d="M1.01995 4.22129L1.37678 3.15184C1.471 2.86988 1.73468 2.67969 2.0321 2.67969H13.9645C14.2616 2.67969 14.5256 2.86988 14.6198 3.15184L14.9766 4.22129C15.0455 4.42766 14.9559 4.63789 14.7889 4.74301C14.7207 4.78555 14.6402 4.81156 14.5516 4.81156H1.44534C1.35675 4.81156 1.27589 4.7859 1.20804 4.74301C1.04069 4.63789 0.951394 4.42766 1.01995 4.22129Z"
              fill={color}
            />
          </svg>
        );
      }

      case "arrow": {
        return (
          <svg
            width={width ?? "17"}
            height={height ?? "14"}
            viewBox="0 0 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.77674 0L8.9786 1.24939L3.55256 6.14425H17V7.85575H3.53488L8.9786 12.7506L7.77674 14L0 7L7.77674 0Z"
              fill={color}
            />
          </svg>
        );
      }

      case "cross_circle_big": {
        return (
          <svg
            width={width ?? "32"}
            height={height ?? "32"}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="7" cy="7" r="7" fill="var(--color-primary-black)" />
            <path
              d="M8.00261 7.10827L9.96453 5.14607C10.0116 5.09897 10.0116 5.02261 9.96453 4.97551L9.23972 4.25043C9.2171 4.22781 9.18635 4.21509 9.15444 4.21509C9.12248 4.21509 9.09179 4.22781 9.06917 4.25043L7.10713 6.21269L5.1451 4.25043C5.09987 4.2052 5.01978 4.2052 4.97455 4.25043L4.24968 4.97551C4.20258 5.02261 4.20258 5.09897 4.24968 5.14607L6.21166 7.10827L4.24968 9.07048C4.20258 9.11758 4.20258 9.19393 4.24968 9.24104L4.97455 9.96605C4.99717 9.98867 5.02786 10.0014 5.05982 10.0014C5.09179 10.0014 5.12248 9.98867 5.1451 9.96605L7.10713 8.00379L9.06917 9.96605C9.09179 9.98867 9.12248 10.0014 9.15444 10.0014C9.18635 10.0014 9.2171 9.98867 9.23972 9.96605L9.96459 9.24104C10.0117 9.19393 10.0117 9.11752 9.96459 9.07048L8.00261 7.10827Z"
              fill="white"
            />
          </svg>
        );
      }

      case "edit_avatar": {
        return (
          <svg
            width={width ?? "22"}
            height={height ?? "22"}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="11"
              cy="11"
              r="11"
              fill="var(--color-secondary-placeholder)"
            />
            <path
              d="M8.1165 7.917L8.339 6.804C8.38433 6.57722 8.50686 6.37316 8.68572 6.22657C8.86459 6.07998 9.08874 5.99991 9.32 6H12.68C12.9113 5.99991 13.1354 6.07998 13.3143 6.22657C13.4931 6.37316 13.6157 6.57722 13.661 6.804L13.8835 7.917C13.9184 8.0914 14.0021 8.2523 14.1249 8.38099C14.2477 8.50969 14.4044 8.60089 14.577 8.644C14.9835 8.74569 15.3443 8.98034 15.6022 9.31065C15.86 9.64096 16 10.048 16 10.467V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H8C7.46957 16 6.96086 15.7893 6.58579 15.4142C6.21071 15.0391 6 14.5304 6 14V10.467C5.99996 10.048 6.13999 9.64096 6.39782 9.31065C6.65566 8.98034 7.0165 8.74569 7.423 8.644C7.59556 8.60089 7.75233 8.50969 7.8751 8.38099C7.99786 8.2523 8.08157 8.0914 8.1165 7.917V7.917Z"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 14C12.1046 14 13 13.1046 13 12C13 10.8954 12.1046 10 11 10C9.89543 10 9 10.8954 9 12C9 13.1046 9.89543 14 11 14Z"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.5 8H11.5"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }

      case "add_circle": {
        return (
          <svg
            width={width ?? "24"}
            height={height ?? "24"}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              fill={color ?? "var(--color-secondary-raspberry-1)"}
            />
            <path
              d="M12.963 11.1795L12.9627 7.27406C12.9627 7.18031 12.8867 7.10431 12.793 7.10431L11.35 7.10405C11.305 7.10404 11.2617 7.12199 11.2299 7.15374C11.1981 7.18555 11.1802 7.22876 11.1802 7.27378L11.1805 11.1794L7.27484 11.1792C7.18481 11.1792 7.1051 11.2589 7.10511 11.3489L7.10531 12.792C7.10531 12.8857 7.18131 12.9617 7.27506 12.9617L11.1806 12.9619L11.1808 16.8674C11.1808 16.9612 11.2568 17.0372 11.3505 17.0372L12.7935 17.0373C12.8385 17.0373 12.8818 17.0194 12.9136 16.9876C12.9454 16.9558 12.9633 16.9126 12.9633 16.8676L12.963 12.962L16.8687 12.9622C16.9137 12.9622 16.9569 12.9443 16.9887 12.9125C17.0204 12.8808 17.0384 12.8375 17.0384 12.7925L17.0382 11.3495C17.0382 11.2557 16.9622 11.1797 16.8685 11.1797L12.963 11.1795Z"
              fill="white"
            />
          </svg>
        );
      }

      case "edit_pen": {
        return (
          <svg
            width={width ?? "19"}
            height={height ?? "19"}
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.94 5.8235L13.1751 2.05966L14.6817 0.554119C15.3524 -0.116665 16.8889 -0.249757 17.6927 0.554119L18.4455 1.30689C19.2494 2.11076 19.1174 3.64718 18.4455 4.31903L16.94 5.8235ZM15.4344 7.3301L4.89353 17.871L0 18.9996L1.12862 14.1061L11.6695 3.56519L15.4344 7.3301Z"
              fill={color}
            />
          </svg>
        );
      }

      case "prev_audio": {
        return (
          <svg
            width={width ?? "20"}
            height={height ?? "24"}
            viewBox="0 0 20 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.75385 13.4621L17.0594 22.1789C18.1941 22.9235 19.709 22.0811 19.694 20.7214L19.4983 3.0018C19.4831 1.61989 17.9503 0.835283 16.8322 1.60626L3.7226 10.6314C2.73585 11.2894 2.75258 12.8051 3.75385 13.4621Z"
              fill={color ?? "white"}
            />
            <line
              x1="2.70252"
              y1="21.099"
              x2="2.49816"
              y2="3.10017"
              stroke={color ?? "white"}
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
        );
      }

      case "next_audio": {
        return (
          <svg
            width={width ?? "19"}
            height={height ?? "22"}
            viewBox="0 0 19 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.8547 9.50544L2.64982 0.632416C1.52365 -0.125581 0 0.699298 0 2.05923V19.783C0 21.1652 1.52365 21.9678 2.64982 21.2098L15.8547 12.3368C16.8484 11.6903 16.8484 10.1743 15.8547 9.50544Z"
              fill={color ?? "white"}
            />
            <line
              x1="17"
              y1="2"
              x2="17"
              y2="20"
              stroke={color ?? "white"}
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
        );
      }

      case "back_audio": {
        return (
          <svg
            width={width ?? "23"}
            height={height ?? "23"}
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.12316 9.22187V8.37187H9.14316V15.4219H8.18316V9.22187H7.12316ZM10.4343 11.8519C10.4343 12.9852 10.6209 13.8685 10.9943 14.5019C11.3676 15.1352 12.0143 15.4519 12.9343 15.4519C13.8543 15.4519 14.5009 15.1352 14.8743 14.5019C15.2543 13.8685 15.4443 12.9852 15.4443 11.8519C15.4443 10.7319 15.2543 9.85521 14.8743 9.22187C14.5009 8.58854 13.8543 8.27187 12.9343 8.27187C12.0143 8.27187 11.3676 8.58854 10.9943 9.22187C10.6209 9.84854 10.4343 10.7252 10.4343 11.8519ZM14.5443 11.8519C14.5443 12.4319 14.5009 12.9185 14.4143 13.3119C14.3343 13.6985 14.1776 14.0085 13.9443 14.2419C13.7109 14.4752 13.3743 14.5919 12.9343 14.5919C12.5009 14.5919 12.1676 14.4752 11.9343 14.2419C11.7009 14.0085 11.5409 13.6985 11.4543 13.3119C11.3743 12.9185 11.3343 12.4319 11.3343 11.8519C11.3343 11.2785 11.3743 10.7985 11.4543 10.4119C11.5409 10.0252 11.7009 9.71854 11.9343 9.49187C12.1676 9.25854 12.5009 9.14187 12.9343 9.14187C13.3743 9.14187 13.7109 9.25854 13.9443 9.49187C14.1776 9.71854 14.3343 10.0252 14.4143 10.4119C14.5009 10.7985 14.5443 11.2785 14.5443 11.8519Z"
              fill={color ?? "white"}
            />
            <path
              d="M23 11.4407C23 14.3861 21.7884 17.2109 19.6317 19.2936C17.4751 21.3763 14.55 22.5464 11.5 22.5464C8.45001 22.5464 5.52494 21.3763 3.36827 19.2936C1.2116 17.2109 4.54484e-08 14.3861 0 11.4407C0 11.1134 0.134623 10.7995 0.374252 10.5681C0.613882 10.3367 0.93889 10.2067 1.27778 10.2067C1.61667 10.2067 1.94167 10.3367 2.1813 10.5681C2.42093 10.7995 2.55556 11.1134 2.55556 11.4407C2.55122 13.3534 3.20297 15.2136 4.409 16.7309C5.61504 18.2481 7.30746 19.3369 9.22192 19.8272C11.1364 20.3174 13.1651 20.1816 14.9911 19.4409C16.8172 18.7001 18.3378 17.3962 19.3155 15.7328C20.2932 14.0693 20.6729 12.14 20.3952 10.2462C20.1176 8.35233 19.1983 6.60061 17.7809 5.26461C16.3635 3.92861 14.5278 3.08356 12.5606 2.86144C10.5934 2.63933 8.60535 3.05265 6.90705 4.03687H7.66667C8.00555 4.03687 8.33056 4.16687 8.57019 4.39829C8.80982 4.6297 8.94444 4.94356 8.94444 5.27083C8.94444 5.5981 8.80982 5.91197 8.57019 6.14338C8.33056 6.37479 8.00555 6.5048 7.66667 6.5048H3.83333C3.66552 6.50484 3.49934 6.47296 3.3443 6.41096C3.18925 6.34896 3.04837 6.25807 2.92971 6.14347C2.81105 6.02888 2.71693 5.89283 2.65273 5.7431C2.58853 5.59337 2.55551 5.43289 2.55556 5.27083V1.56893C2.55556 1.24166 2.69018 0.927796 2.92981 0.696382C3.16944 0.464968 3.49445 0.334961 3.83333 0.334961C4.17222 0.334961 4.49723 0.464968 4.73686 0.696382C4.97649 0.927796 5.11111 1.24166 5.11111 1.56893V2.20319C6.8432 1.08713 8.85649 0.445988 10.9363 0.348145C13.0161 0.250302 15.0843 0.699424 16.9206 1.64762C18.7568 2.59581 20.2921 4.00751 21.3628 5.73218C22.4334 7.45685 22.9993 9.42982 23 11.4407Z"
              fill={color ?? "white"}
            />
          </svg>
        );
      }

      case "play_audio": {
        return (
          <svg
            width={width ?? "17"}
            height={height ?? "22"}
            viewBox="0 0 17 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.8547 9.50544L2.64982 0.632416C1.52365 -0.125581 0 0.699298 0 2.05923V19.783C0 21.1652 1.52365 21.9678 2.64982 21.2098L15.8547 12.3368C16.8484 11.6903 16.8484 10.1743 15.8547 9.50544Z"
              fill={color ?? "white"}
            />
          </svg>
        );
      }

      case "pause_audio": {
        return (
          <svg
            width={width ?? "14"}
            height={height ?? "23"}
            viewBox="0 0 14 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.13748 22.5462H1.76648C0.79096 22.5462 0 21.7476 0 20.7627V2.39576C0 1.41087 0.79096 0.612305 1.76648 0.612305H3.13748C4.11299 0.612305 4.93032 1.41087 4.93032 2.39576V20.7627C4.93032 21.7476 4.11299 22.5462 3.13748 22.5462ZM12.2335 22.5462H10.8362C9.86064 22.5462 9.06968 21.7476 9.06968 20.7627V11.5793V2.39576C9.06968 1.41087 9.86064 0.612305 10.8362 0.612305H12.2335C13.209 0.612305 14 1.41087 14 2.39576V20.7627C14 21.7476 13.209 22.5462 12.2335 22.5462Z"
              fill={color ?? "white"}
            />
          </svg>
        );
      }

      case "delete_account": {
        return (
          <svg
            width={width ?? "16"}
            height={height ?? "17"}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="8"
              cy="8.32016"
              r="8"
              fill="var(--color-secondary-orange-3)"
            />
            <path
              d="M8.86004 4.10713H7.23532V4.38055H6.64862V4.06877C6.64843 3.76629 6.8945 3.5202 7.19678 3.5202H8.89858C9.20086 3.5202 9.44693 3.76629 9.44693 4.06877V4.38036H8.86004V4.10713Z"
              fill="white"
            />
            <path
              d="M5.29392 6.70563H10.802C10.9529 6.70563 11.0718 6.83437 11.0596 6.98495L10.5992 12.6798C10.5734 12.9977 10.3083 13.2425 9.98976 13.2425H6.10633C5.78775 13.2425 5.5227 12.9977 5.49707 12.6797L5.03665 6.98495C5.02412 6.83437 5.14298 6.70563 5.29392 6.70563ZM9.46821 12.635C9.47429 12.6354 9.48055 12.6356 9.48663 12.6356C9.64042 12.6356 9.76952 12.5158 9.7792 12.3603L10.0678 7.68506C10.0777 7.52328 9.95464 7.38409 9.79306 7.37403C9.63187 7.36415 9.49213 7.48701 9.48207 7.64879L9.19348 12.324C9.18361 12.486 9.30664 12.625 9.46821 12.635ZM7.75129 12.3422C7.75129 12.5042 7.88268 12.6356 8.04463 12.6356C8.20658 12.6356 8.33797 12.5042 8.33797 12.3422V7.66702C8.33797 7.50486 8.20658 7.37365 8.04463 7.37365C7.88268 7.37365 7.75129 7.50505 7.75129 7.66702V12.3422ZM6.02811 7.6843L6.3036 12.3595C6.31271 12.5154 6.44201 12.6356 6.59618 12.6356C6.60187 12.6356 6.60776 12.6354 6.61364 12.6352C6.7754 12.6257 6.89882 12.4867 6.88932 12.3249L6.61383 7.64974C6.60434 7.48796 6.46593 7.36453 6.30379 7.37403C6.14203 7.38352 6.01862 7.52252 6.02811 7.6843Z"
              fill="white"
            />
            <path
              d="M4.27914 5.80002L4.47185 5.22237C4.52273 5.07008 4.66513 4.96735 4.82576 4.96735H11.27C11.4304 4.96735 11.573 5.07008 11.6239 5.22237L11.8166 5.80002C11.8538 5.91148 11.8054 6.02504 11.7152 6.08181C11.6784 6.10479 11.6349 6.11884 11.5871 6.11884H4.50887C4.46103 6.11884 4.41736 6.10498 4.38071 6.08181C4.29034 6.02504 4.24211 5.91148 4.27914 5.80002Z"
              fill="white"
            />
          </svg>
        );
      }

      case "heart": {
        return (
          <svg
            width={width ?? "18"}
            height={height ?? "16"}
            viewBox="0 0 32 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 3.86532C15.5899 3.40322 15.131 2.90617 14.6023 2.42747C13.1896 1.14822 11.2786 0 8.47059 0C3.76471 0 0 3.77104 0 8.48485C0 14.1414 3.29412 17.6296 15.4353 27.5286L16 28L16.5647 27.5286C28.7059 17.6296 32 14.1414 32 8.48485C32 3.77104 28.2353 0 23.5294 0C20.7214 0 18.8104 1.14822 17.3977 2.42747C16.869 2.90617 16.4101 3.40322 16 3.86532Z"
              fill={color ?? "var(--color-primary-black)"}
            />
          </svg>
        );
      }

      case "heart_outlined": {
        return (
          <svg
            width={width ?? "18"}
            height={height ?? "16"}
            viewBox="0 0 32 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.6023 2.42747C15.131 2.90617 15.5899 3.40322 16 3.86532C16.4101 3.40322 16.869 2.90617 17.3977 2.42747C18.8104 1.14822 20.7214 0 23.5294 0C28.2353 0 32 3.77104 32 8.48485C32 14.1414 28.7059 17.6296 16.5647 27.5286L16 28L15.4353 27.5286C3.29412 17.6296 0 14.1414 0 8.48485C0 3.77104 3.76471 0 8.47059 0C11.2786 0 13.1896 1.14822 14.6023 2.42747ZM16 25.4076C21.6862 20.7552 25.187 17.676 27.2973 15.1374C29.3876 12.6227 30 10.7766 30 8.48485C30 4.87244 27.1276 2 23.5294 2C20.5752 2 18.9208 3.58712 17.4959 5.1928L16 6.87855L14.5041 5.1928C13.0792 3.58712 11.4248 2 8.47059 2C4.87245 2 2 4.87244 2 8.48485C2 10.7766 2.61243 12.6227 4.70273 15.1374C6.81298 17.676 10.3138 20.7552 16 25.4076Z"
              fill={color ?? "var(--color-primary-black)"}
            />
          </svg>
        );
      }

      case "filter": {
        return (
          <svg
            width={width ?? "16"}
            height={height ?? "20"}
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              y="4.46155"
              width="16"
              height="2.46154"
              fill={color ?? "white"}
            />
            <rect
              x="16"
              y="15.5385"
              width="16"
              height="2.46154"
              transform="rotate(180 16 15.5385)"
              fill={color ?? "white"}
            />
            <rect
              x="3.69297"
              y="2"
              width="2.46154"
              height="7.38462"
              fill={color ?? "white"}
            />
            <rect
              x="12.308"
              y="18"
              width="2.46154"
              height="7.38462"
              transform="rotate(180 12.308 18)"
              fill={color ?? "white"}
            />
          </svg>
        );
      }

      case "paperscroll": {
        return (
          <svg
            width={width ?? "16"}
            height={height ?? "16"}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 11.705C0 11.3795 0.263916 11.1156 0.589472 11.1156H10.021C10.3466 11.1156 10.6105 11.3795 10.6105 11.705C10.6105 12.0306 10.3466 12.2945 10.021 12.2945H1.17894V12.3787C1.17894 13.5414 2.12148 14.484 3.2842 14.484H12.0421C12.3676 14.484 12.6315 14.7479 12.6315 15.0735C12.6315 15.399 12.3676 15.6629 12.0421 15.6629H3.2842C1.47037 15.6629 0 14.1926 0 12.3787V11.705Z"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.30525 1.51566C4.88694 1.51566 4.54735 1.85525 4.54735 2.27355V11.1156H10.021C10.3466 11.1156 10.6105 11.3796 10.6105 11.7051V12.3788C10.6105 13.5415 11.553 14.484 12.7158 14.484C13.8785 14.484 14.821 13.5415 14.821 12.3788V2.27355C14.821 1.85525 14.4814 1.51566 14.0631 1.51566H5.30525ZM3.36841 2.27355C3.36841 1.20414 4.23583 0.336716 5.30525 0.336716H14.0631C15.1325 0.336716 16 1.20414 16 2.27355V12.3788C16 14.1926 14.5296 15.663 12.7158 15.663C10.9019 15.663 9.43155 14.1926 9.43155 12.3788V12.2946H3.95788C3.63232 12.2946 3.36841 12.0307 3.36841 11.7051V2.27355Z"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.73706 4.29472C6.73706 3.96916 7.00098 3.70525 7.32653 3.70525H12.0423C12.3679 3.70525 12.6318 3.96916 12.6318 4.29472C12.6318 4.62027 12.3679 4.88419 12.0423 4.88419H7.32653C7.00098 4.88419 6.73706 4.62027 6.73706 4.29472Z"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.73706 7.663C6.73706 7.33745 7.00098 7.07353 7.32653 7.07353H12.0423C12.3679 7.07353 12.6318 7.33745 12.6318 7.663C12.6318 7.98856 12.3679 8.25248 12.0423 8.25248H7.32653C7.00098 8.25248 6.73706 7.98856 6.73706 7.663Z"
              fill={color ?? "var(--color-primary-black)"}
            />
          </svg>
        );
      }

      case "invite_down_arrow": {
        return (
          <svg
            width={width ?? "33"}
            height={height ?? "39"}
            viewBox="0 0 33 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.499999 21.153L3.35574 18.4062L14.544 30.8072L14.544 0.0734755L18.456 0.0734757L18.456 30.8476L29.6443 18.4062L32.5 21.153L16.5 38.9265L0.499999 21.153Z"
              fill={color ?? "var(--color-secondary-raspberry-1)"}
            />
          </svg>
        );
      }

      case "documents": {
        return (
          <svg
            width={width ?? "18"}
            height={height ?? "20"}
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.11542 6.73041C4.26222 6.57872 4.46429 6.49307 4.67538 6.49307H9.61051C10.3266 6.49307 10.9092 7.07572 10.9092 7.79179V18.701C10.9092 19.4171 10.3266 19.9997 9.61051 19.9997H1.29872C0.582644 19.9997 0 19.4171 0 18.701V11.2984C0 11.0962 0.0786286 10.9018 0.21927 10.7565L4.11542 6.73041ZM5.00566 8.05153L1.55846 11.6137V18.4413H9.35077V8.05153H5.00566Z"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.67538 7.14221C5.10574 7.14221 5.45462 7.49109 5.45462 7.92144V11.8176C5.45462 12.248 5.10574 12.5968 4.67538 12.5968H0.779231C0.348873 12.5968 0 12.248 0 11.8176C0 11.3872 0.348873 11.0384 0.779231 11.0384H3.89615V7.92144C3.89615 7.49109 4.24503 7.14221 4.67538 7.14221Z"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.23413 3.89601C6.23413 3.46565 6.583 3.11678 7.01336 3.11678H12.7277C13.4438 3.11678 14.0264 3.69942 14.0264 4.41549V14.8052C14.0264 15.2356 13.6776 15.5845 13.2472 15.5845C12.8169 15.5845 12.468 15.2356 12.468 14.8052V4.67524H7.01336C6.583 4.67524 6.23413 4.32636 6.23413 3.89601Z"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.35083 0.778987C9.35083 0.348629 9.6997 -0.000244141 10.1301 -0.000244141H15.8444C16.5605 -0.000244141 17.1431 0.582399 17.1431 1.29847V11.6882C17.1431 12.1186 16.7943 12.4674 16.3639 12.4674C15.9335 12.4674 15.5847 12.1186 15.5847 11.6882V1.55822H10.1301C9.6997 1.55822 9.35083 1.20934 9.35083 0.778987Z"
              fill={color ?? "var(--color-primary-black)"}
            />
          </svg>
        );
      }

      case "company": {
        return (
          <svg
            width={width ?? "19"}
            height={height ?? "20"}
            viewBox="0 0 19 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.80868 2.61105C4.59099 2.61105 4.38224 2.69745 4.22803 2.85167C4.07381 3.00588 3.98741 3.21464 3.98741 3.43232V17.3889H15.0121V3.43232C15.0121 3.21482 14.9254 3.00557 14.7715 2.85167C14.6173 2.69745 14.4086 2.61105 14.1909 2.61105H4.80868ZM17.1232 17.3889V3.43232C17.1232 2.65444 16.8137 1.90837 16.2643 1.35892C15.7142 0.808895 14.9686 0.499992 14.1909 0.499992H4.80868C4.03098 0.499992 3.28531 0.808895 2.73528 1.35892C2.18525 1.90895 1.87635 2.65462 1.87635 3.43232V17.3889H1.05553C0.472577 17.3889 0 17.8615 0 18.4445C0 19.0274 0.472577 19.5 1.05553 19.5H17.944C18.527 19.5 18.9996 19.0274 18.9996 18.4445C18.9996 17.8615 18.527 17.3889 17.944 17.3889H17.1232ZM5.6295 6.24707C5.6295 5.66411 6.10208 5.19154 6.68503 5.19154H7.62343C8.20638 5.19154 8.67896 5.66411 8.67896 6.24707C8.67896 6.83002 8.20638 7.3026 7.62343 7.3026H6.68503C6.10208 7.3026 5.6295 6.83002 5.6295 6.24707ZM10.3206 6.24707C10.3206 5.66411 10.7932 5.19154 11.3761 5.19154H12.3145C12.8975 5.19154 13.3701 5.66411 13.3701 6.24707C13.3701 6.83002 12.8975 7.3026 12.3145 7.3026H11.3761C10.7932 7.3026 10.3206 6.83002 10.3206 6.24707ZM5.6295 10.0002C5.6295 9.41726 6.10208 8.94468 6.68503 8.94468H7.62343C8.20638 8.94468 8.67896 9.41726 8.67896 10.0002C8.67896 10.5832 8.20638 11.0557 7.62343 11.0557H6.68503C6.10208 11.0557 5.6295 10.5832 5.6295 10.0002ZM10.3206 10.0002C10.3206 9.41726 10.7932 8.94468 11.3761 8.94468H12.3145C12.8975 8.94468 13.3701 9.41726 13.3701 10.0002C13.3701 10.5832 12.8975 11.0557 12.3145 11.0557H11.3761C10.7932 11.0557 10.3206 10.5832 10.3206 10.0002ZM5.6295 13.7534C5.6295 13.1704 6.10208 12.6978 6.68503 12.6978H7.62343C8.20638 12.6978 8.67896 13.1704 8.67896 13.7534C8.67896 14.3363 8.20638 14.8089 7.62343 14.8089H6.68503C6.10208 14.8089 5.6295 14.3363 5.6295 13.7534ZM10.3206 13.7534C10.3206 13.1704 10.7932 12.6978 11.3761 12.6978H12.3145C12.8975 12.6978 13.3701 13.1704 13.3701 13.7534C13.3701 14.3363 12.8975 14.8089 12.3145 14.8089H11.3761C10.7932 14.8089 10.3206 14.3363 10.3206 13.7534Z"
              fill={color ?? "var(--color-primary-black)"}
            />
          </svg>
        );
      }

      case "playlist": {
        return (
          <svg
            width={width ?? "16"}
            height={height ?? "16"}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 4.9171H0V6.9075H16V4.9171Z"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              d="M16 0.750703H0C0 0.641903 0 2.8819 0 2.7411H16"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              d="M15.5266 11.3747L11.901 9.30107C11.277 8.94587 10.5186 9.38427 10.5186 10.1107V14.2419C10.5186 14.9491 11.277 15.3875 11.901 15.0515L15.5266 12.9779C16.1346 12.6227 16.1346 11.7299 15.5266 11.3747Z"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              d="M8.6656 9.0803H0V11.0707H8.6656V9.0803Z"
              fill={color ?? "var(--color-primary-black)"}
            />
            <path
              d="M8.6656 13.2627H0V15.2531H8.6656V13.2627Z"
              fill={color ?? "var(--color-primary-black)"}
            />
          </svg>
        );
      }

      case "external": {
        return (
          <svg
            width={width ?? "13"}
            height={height ?? "12"}
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.61869 10.8306V4.3197L9.61976 4.06373L9.43813 4.24535L1.68242 12L0 10.3186L7.75677 2.56187L7.9384 2.38024H7.68242L1.17153 2.38237V0.00212427L12.0021 0L12 10.8306H9.61976H9.61869Z"
              fill={color ?? "var(--color-primary-yellow)"}
            />
          </svg>
        );
      }

      case "brain": {
        return (
          <svg
            width={width ?? "27"}
            height={height ?? "25"}
            viewBox="0 0 27 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.5737 21.5581C19.3568 21.4832 19.1525 21.3909 18.9619 21.3033C18.8501 21.2528 18.7451 21.2039 18.6439 21.1632C18.5768 21.1361 18.5095 21.1087 18.4425 21.0815C17.923 20.8715 17.39 20.6565 16.9319 20.2858C16.8171 20.1935 16.676 20.1398 16.5291 20.1398H15.6197C15.3765 20.1398 15.2443 20.4247 15.4017 20.6106L16.0553 21.3839C16.6583 22.0423 17.3995 23.0356 17.8197 24.2748C17.8976 24.5033 18.1114 24.6591 18.3538 24.6591H19.5726C19.7585 24.6591 19.9081 24.5082 19.9081 24.3236V22.0357C19.9073 21.8205 19.7751 21.627 19.5737 21.5581L19.5737 21.5581Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M10.5401 20.6952C10.5401 20.4015 10.3018 20.1641 10.009 20.1641H2.83258C2.53892 20.1641 2.30145 20.4024 2.30145 20.6952C2.30145 20.988 2.53974 21.2263 2.83258 21.2263H10.009C10.3026 21.2263 10.5398 20.9888 10.5398 20.6952H10.5401Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M13.1629 12.8643L14.8573 14.3165H22.2803C23.1947 14.3165 24.0819 14.053 24.8453 13.5558C26.1956 12.6825 27 11.2028 27 9.59695C27 8.05621 26.249 6.55916 25.0606 5.67901L23.7725 6.75106C23.6732 6.83383 23.5527 6.87454 23.4322 6.87454C23.2767 6.87454 23.122 6.80642 23.017 6.67506C22.834 6.44654 22.8818 6.11001 23.1065 5.9222L24.4231 4.82493C23.9378 3.37944 22.5865 2.3943 21.0341 2.3943C20.4311 2.3943 19.9602 2.58781 19.4448 2.90996V5.26111C19.4448 5.54417 19.2309 5.79115 18.9487 5.8096C18.6393 5.82996 18.3817 5.58488 18.3817 5.27956V2.71811C17.8653 1.35731 16.3742 0.340912 14.8761 0.340912C13.6008 0.340912 12.386 0.978972 11.7371 1.97608V4.72971C11.7371 5.01278 11.5232 5.25975 11.2409 5.2782C10.9315 5.29856 10.674 5.05348 10.674 4.74816V2.08492C10.0679 1.63956 9.43963 1.42922 8.71505 1.42922C6.9808 1.42922 5.4322 2.64891 5.09266 4.27429V6.32577C5.09266 6.60884 4.8788 6.85581 4.59655 6.87426C4.28715 6.89462 4.02959 6.64954 4.02959 6.34422V5.11481C4.02959 4.93378 3.86431 4.79781 3.68627 4.83174C2.06951 5.13924 0.736992 6.28779 0.235151 7.88197C-0.431131 10.0024 0.349949 12.1969 2.17943 13.3447C2.24375 13.3857 2.29993 13.437 2.34281 13.5002L4.17447 16.2063C4.22115 16.2752 4.60056 16.5933 4.87383 16.8289C4.98375 16.9233 5.12379 16.9757 5.26872 16.9757L9.32694 16.976C9.61001 16.976 9.85698 17.1899 9.87543 17.4721C9.89579 17.7815 9.65072 18.0391 9.34539 18.0391H7.16169C6.97117 18.0391 6.89518 18.2841 7.05178 18.3922L7.21434 18.504C7.67626 18.6557 8.16182 18.7501 8.6606 18.7841L13.3509 19.1021H16.8401L17.9712 18.0138C18.1813 17.8116 18.5197 17.7978 18.7271 18.0011C18.942 18.2122 18.9401 18.5564 18.7241 18.7645L17.8437 19.6118C18.1539 19.8161 18.5246 19.966 18.9097 20.1215C18.9787 20.1497 19.0479 20.1768 19.116 20.2051C19.2357 20.2536 19.3554 20.3082 19.471 20.3606C19.7812 20.5017 20.1023 20.6474 20.3892 20.6719C20.5243 20.6835 20.6527 20.6895 20.7716 20.6895C23.0945 20.6895 25.0049 18.8744 25.1205 16.5567C25.1264 16.4438 25.1186 16.3203 25.0961 16.1648L25.0377 15.7563L24.886 15.2195C24.8266 15.0094 24.5991 14.8976 24.3958 14.9782C23.7266 15.2428 23.0106 15.3799 22.2803 15.3799H14.8315L13.1098 16.6093C13.0164 16.6763 12.9084 16.7086 12.8015 16.7086C12.6254 16.7086 12.4514 16.621 12.3491 16.4576C12.1993 16.2174 12.2761 15.8982 12.5068 15.734L13.8005 14.8099L12.4541 13.657C12.2275 13.4624 12.2041 13.118 12.4074 12.8954C12.6039 12.6805 12.9423 12.6745 13.1633 12.8642L13.1629 12.8643ZM10.2603 10.596C8.28105 10.596 6.58752 11.9568 6.14189 13.904C6.08544 14.1502 5.86669 14.3174 5.62433 14.3174C5.58145 14.3174 5.53775 14.3125 5.49406 14.3008C5.21207 14.2297 5.04462 13.9342 5.10976 13.65C5.43083 12.2659 6.25942 11.1211 7.37023 10.3924L6.03222 8.8324C5.84251 8.61148 5.84849 8.27304 6.06343 8.07654C6.28625 7.87435 6.63039 7.89661 6.82498 8.12322L8.34127 9.89165C8.93863 9.65906 9.58646 9.53178 10.2614 9.53178H16.5674L18.0061 8.09309C18.2173 7.88194 18.5625 7.88601 18.7695 8.10476C18.969 8.31673 18.9484 8.65435 18.7424 8.86061L17.5393 10.0637L18.7446 11.269C18.9441 11.4685 18.9701 11.7934 18.7845 12.0064C18.6784 12.129 18.5308 12.1901 18.3818 12.1901C18.2455 12.1901 18.1093 12.1385 18.0064 12.0346L16.5677 10.5959L10.2603 10.596Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M4.82484 18.2412C4.94154 18.2412 4.98822 18.0903 4.89187 18.0244L3.82205 17.2862C3.82015 17.2832 3.81716 17.2802 3.81418 17.2775C3.75583 17.2132 3.67223 17.1782 3.58566 17.1782H0.855373C0.572305 17.1782 0.325331 17.392 0.306877 17.6743C0.286522 17.9837 0.531598 18.2412 0.83692 18.2412H4.82484Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M11.8692 23.3527H4.69281C4.39915 23.3527 4.16168 23.591 4.16168 23.8838C4.16168 24.1767 4.39997 24.415 4.69281 24.415H11.8692C12.1629 24.415 12.4003 24.1767 12.4003 23.8838C12.4003 23.591 12.1631 23.3527 11.8692 23.3527Z"
              fill="var(--color-primary-black)"
            />
          </svg>
        );
      }

      case "metricTotalArticlesRead": {
        return (
          <svg
            width={width ?? "48"}
            height={height ?? "49"}
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="24"
              cy="24.5"
              r="24"
              fill="var(--color-secondary-soft-yellow-2)"
            />
            <path
              d="M34.4998 14C31.3091 14.0007 28.1623 14.6911 25.3083 16.0166L23.9997 16.6225L22.6947 16.0166C19.8398 14.6909 16.6917 14.0005 13.4999 14C13.102 14 12.7206 14.1467 12.4392 14.4081C12.158 14.6693 12 15.0237 12 15.3932V29.3242C12 29.6934 12.158 30.0479 12.4392 30.309C12.7206 30.5704 13.102 30.7171 13.4999 30.7171C16.2258 30.7169 18.914 31.306 21.3527 32.4376L23.329 33.3535C23.7504 33.5488 24.246 33.5488 24.6677 33.3535L26.6439 32.434V32.4342C29.0837 31.3031 31.7735 30.7152 34.5001 30.7172C34.898 30.7172 35.2794 30.5705 35.5608 30.3091C35.842 30.0479 36 29.6935 36 29.3242V15.3933C36 15.0238 35.842 14.6693 35.5608 14.4082C35.2794 14.1468 34.898 14.0001 34.5001 14.0001L34.4998 14ZM22.4999 29.8601C20.1501 28.799 17.6052 28.1608 14.9999 27.9795V16.8348C17.2108 17.0129 19.3659 17.5765 21.3523 18.496L22.4999 19.0392V29.8601ZM32.9998 27.9795H32.9995C30.3942 28.1608 27.8493 28.799 25.4996 29.8601V19.0394L26.6471 18.5066C28.6336 17.5871 30.7887 17.0235 32.9995 16.8454L32.9998 27.9795Z"
              fill="var(--color-primary-yellow)"
            />
          </svg>
        );
      }

      case "metricTotalArticlesSaved": {
        return (
          <svg
            width={width ?? "48"}
            height={height ?? "48"}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="24"
              cy="24"
              r="24"
              fill="var(--color-secondary-soft-pink-1)"
            />
            <path
              d="M15 15.7013V34.1491C15 34.9511 15.4936 35.6298 16.234 35.8766C16.4499 35.9383 16.6658 36 16.8818 36C17.4062 36 17.9307 35.7532 18.27 35.3522L23.3909 29.3989L28.481 35.3219C28.9746 35.9389 29.7767 36.1548 30.5479 35.8772C31.2883 35.5995 31.7819 34.9208 31.7819 34.1496V15.7019C31.7819 13.6658 30.1166 12 28.08 12H18.7019C16.6658 12 15 13.6658 15 15.7019V15.7013ZM29.314 15.7013V32.4832L24.81 27.2697C24.4707 26.8378 23.9462 26.591 23.3909 26.591C22.8357 26.591 22.3112 26.8378 21.9719 27.2389L17.4679 32.4832V15.7013C17.4679 15.0227 18.0232 14.4674 18.7019 14.4674H28.0491C28.7587 14.4674 29.314 15.0227 29.314 15.7013Z"
              fill="var(--color-secondary-raspberry-1)"
            />
          </svg>
        );
      }

      case "metricTotalArticlesShared": {
        return (
          <svg
            width={width ?? "48"}
            height={height ?? "49"}
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="24" cy="24.5" r="24" fill="#EEFBF0" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.0592 14.1959C34.106 14.2293 34.1503 14.2668 34.1918 14.3082C34.3011 14.4175 34.3827 14.5471 34.4345 14.6867C34.518 14.9123 34.5234 15.1642 34.4409 15.3998L26.7074 37.4954C26.5649 37.9026 26.1883 38.1815 25.7572 38.1991C25.3262 38.2167 24.9281 37.9694 24.7528 37.5752L20.4981 28.0019L10.9249 23.7472C10.5306 23.572 10.2833 23.1738 10.3009 22.7428C10.3185 22.3117 10.5974 21.9351 11.0046 21.7926L33.0734 14.0685C33.397 13.9456 33.7691 13.9881 34.0592 14.1959ZM29.4431 17.5686L14.2047 22.9021L21.062 25.9497L29.4431 17.5686ZM22.5501 27.4376L30.9317 19.056L25.598 34.2953L22.5501 27.4376Z"
              fill="var(--color-secondary-green-1)"
            />
          </svg>
        );
      }

      case "metricTotalReadingTimeSaved": {
        return (
          <svg
            width={width ?? "48"}
            height={height ?? "48"}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="24" cy="24" r="24" fill="#EEF9FB" />
            <path
              d="M35.3948 24.2598C35.0718 23.9296 34.6495 23.7143 34.1929 23.6462C33.7362 23.5781 33.2698 23.6604 32.8638 23.881L27.8901 26.6026C27.5729 26.2245 27.1201 25.9851 26.6291 25.9359L21.8344 25.4792C20.5118 25.3534 19.1905 25.7263 18.1294 26.5255L15.3007 28.6497L15.1145 28.3313C14.9141 27.9836 14.4698 27.8649 14.1221 28.0653L11.1598 29.7771C10.8121 29.9775 10.6934 30.4218 10.8938 30.7695L15.5971 38.9144C15.7268 39.1388 15.9668 39.2777 16.2263 39.2777C16.3534 39.2777 16.4792 39.2446 16.5895 39.1804L19.5538 37.4706C19.7211 37.3746 19.8431 37.2156 19.8937 37.0295C19.9436 36.8427 19.9177 36.6442 19.821 36.4768L19.1646 35.3417L20.3081 34.5206L27.5599 33.6721C28.7988 33.5288 29.9475 32.9547 30.807 32.0505L35.4142 27.1961C35.7937 26.7998 36.0038 26.2718 36 25.7237C35.9967 25.1756 35.7794 24.6503 35.3954 24.2591L35.3948 24.2598ZM16.4916 37.5588L12.5148 30.6715L14.222 29.6882L18.1975 36.5735L16.4916 37.5588ZM34.3628 26.1953L29.751 31.051C29.127 31.7074 28.2922 32.1238 27.3925 32.2296L19.9533 33.1013C19.8314 33.1156 19.7146 33.1604 19.6147 33.2317L18.4362 34.0775L16.0304 29.9165L18.9972 27.6865C19.7698 27.1073 20.7298 26.8362 21.691 26.925L26.4858 27.3817C26.6109 27.394 26.7257 27.4582 26.801 27.5587C26.8788 27.6651 26.9067 27.7994 26.8782 27.9278C26.838 28.1308 26.6635 28.2794 26.4566 28.2865L22.5466 28.4318C22.1464 28.4467 21.8337 28.7827 21.848 29.1836C21.8662 29.5831 22.2009 29.8945 22.6004 29.8841L26.5091 29.7388C26.9391 29.7252 27.351 29.5643 27.6779 29.2848C28.0049 29.0045 28.226 28.6219 28.3052 28.1989C28.3143 28.1399 28.3201 28.0802 28.3227 28.0199L33.5663 25.1633C33.8277 25.0226 34.1507 25.0712 34.3596 25.2827C34.6034 25.5389 34.6034 25.9404 34.3596 26.1966H34.3621L34.3628 26.1953ZM25.0639 23.8823C27.0741 23.881 29.0012 23.0819 30.4217 21.66C31.8422 20.2382 32.64 18.3105 32.6394 16.301C32.6394 14.2909 31.8402 12.3638 30.4191 10.9426C28.9979 9.52081 27.0702 8.72234 25.0607 8.72234C23.0506 8.72234 21.1228 9.52016 19.7017 10.9413C18.2799 12.3625 17.4814 14.2896 17.4801 16.2997C17.4814 18.3098 18.2805 20.2369 19.7017 21.6587C21.1228 23.0806 23.0499 23.8803 25.0601 23.8829H25.0646L25.0639 23.8823ZM25.0639 10.1753C26.6888 10.1766 28.2468 10.8233 29.3949 11.9727C30.543 13.1227 31.1877 14.6814 31.1864 16.3062C31.1851 17.931 30.5391 19.4891 29.3891 20.6378C28.2397 21.7859 26.681 22.4306 25.0562 22.4293C23.4313 22.4287 21.8733 21.782 20.7246 20.6326C19.5758 19.4826 18.9317 17.9245 18.9324 16.2997C18.935 14.6755 19.581 13.1188 20.7298 11.9707C21.8785 10.8226 23.4352 10.1766 25.0594 10.1753H25.0639ZM21.7792 16.2997C21.7792 15.8982 22.1042 15.5732 22.5057 15.5732H24.3336V12.5739C24.3336 12.1724 24.6585 11.8475 25.0601 11.8475C25.4616 11.8475 25.7865 12.1731 25.7865 12.5739V16.2991C25.7865 16.4917 25.71 16.6766 25.5738 16.8128C25.4376 16.949 25.2527 17.0255 25.0601 17.0255H22.5057C22.1042 17.0255 21.7792 16.6999 21.7792 16.2991V16.2997Z"
              fill="#2A8AA8"
            />
          </svg>
        );
      }

      case "metricTotalVideosWatched": {
        return (
          <svg
            width={width ?? "48"}
            height={height ?? "49"}
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="24"
              cy="24.5"
              r="24"
              fill="var(--color-secondary-soft-yellow-2)"
            />
            <path
              d="M28.555 21.1675L22.555 17.1675C22.4044 17.067 22.2293 17.0093 22.0484 17.0005C21.8675 16.9918 21.6877 17.0323 21.528 17.1177C21.3684 17.2032 21.2349 17.3304 21.1419 17.4858C21.0489 17.6412 20.9999 17.8189 21 18V26C20.9999 26.1811 21.0489 26.3588 21.1419 26.5142C21.2349 26.6696 21.3684 26.7968 21.528 26.8823C21.6877 26.9677 21.8675 27.0082 22.0484 26.9995C22.2293 26.9907 22.4044 26.933 22.555 26.8325L28.555 22.8325C28.6922 22.7412 28.8047 22.6175 28.8825 22.4722C28.9603 22.327 29.001 22.1648 29.001 22C29.001 21.8352 28.9603 21.673 28.8825 21.5278C28.8047 21.3825 28.6922 21.2588 28.555 21.1675ZM23 24.1313V19.875L26.1975 22L23 24.1313ZM35 13H13C12.4696 13 11.9609 13.2107 11.5858 13.5858C11.2107 13.9609 11 14.4696 11 15V29C11 29.5304 11.2107 30.0391 11.5858 30.4142C11.9609 30.7893 12.4696 31 13 31H35C35.5304 31 36.0391 30.7893 36.4142 30.4142C36.7893 30.0391 37 29.5304 37 29V15C37 14.4696 36.7893 13.9609 36.4142 13.5858C36.0391 13.2107 35.5304 13 35 13ZM35 29H13V15H35V29ZM37 34C37 34.2652 36.8946 34.5196 36.7071 34.7071C36.5196 34.8946 36.2652 35 36 35H12C11.7348 35 11.4804 34.8946 11.2929 34.7071C11.1054 34.5196 11 34.2652 11 34C11 33.7348 11.1054 33.4804 11.2929 33.2929C11.4804 33.1054 11.7348 33 12 33H36C36.2652 33 36.5196 33.1054 36.7071 33.2929C36.8946 33.4804 37 33.7348 37 34Z"
              fill="var(--color-secondary-orange-2)"
            />
          </svg>
        );
      }

      case "metricTotalVideosSaved": {
        return (
          <svg
            width={width ?? "48"}
            height={height ?? "49"}
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              opacity="0.1"
              cx="24"
              cy="24.5"
              r="24"
              fill="var(--color-secondary-orange-3)"
            />
            <path
              d="M26.5287 27.1513C26.3847 27.0616 26.2202 27.0101 26.0507 27.0016C25.8812 26.993 25.7123 27.0278 25.56 27.1025L22.9075 28.4013C22.7801 27.9951 22.5264 27.6402 22.1833 27.3882C21.8402 27.1361 21.4257 27.0002 21 27H14C13.4696 27 12.9609 27.2107 12.5858 27.5858C12.2107 27.9609 12 28.4696 12 29V34C12 34.5304 12.2107 35.0391 12.5858 35.4142C12.9609 35.7893 13.4696 36 14 36H21C21.4401 35.9995 21.8678 35.8538 22.2168 35.5856C22.5657 35.3173 22.8164 34.9415 22.93 34.5163L25.535 35.8913C25.6879 35.9715 25.8589 36.0109 26.0315 36.0055C26.204 36 26.3723 35.95 26.5198 35.8603C26.6673 35.7705 26.789 35.6441 26.8732 35.4934C26.9573 35.3426 27.001 35.1727 27 35V28C27 27.8302 26.9567 27.6631 26.8743 27.5146C26.7918 27.3661 26.6729 27.2411 26.5287 27.1513ZM21 34H14V29H21V32.875C21 32.8913 21 32.9062 21 32.9225V34ZM25 33.345L23 32.2925V30.5825L25 29.6038V33.345ZM34.7075 18.2925L27.7075 11.2925C27.6146 11.1997 27.5042 11.1261 27.3829 11.0759C27.2615 11.0257 27.1314 10.9999 27 11H15C14.4696 11 13.9609 11.2107 13.5858 11.5858C13.2107 11.9609 13 12.4696 13 13V24C13 24.2652 13.1054 24.5196 13.2929 24.7071C13.4804 24.8946 13.7348 25 14 25C14.2652 25 14.5196 24.8946 14.7071 24.7071C14.8946 24.5196 15 24.2652 15 24V13H26V19C26 19.2652 26.1054 19.5196 26.2929 19.7071C26.4804 19.8946 26.7348 20 27 20H33V35H30C29.7348 35 29.4804 35.1054 29.2929 35.2929C29.1054 35.4804 29 35.7348 29 36C29 36.2652 29.1054 36.5196 29.2929 36.7071C29.4804 36.8946 29.7348 37 30 37H33C33.5304 37 34.0391 36.7893 34.4142 36.4142C34.7893 36.0391 35 35.5304 35 35V19C35.0001 18.8686 34.9743 18.7385 34.9241 18.6172C34.8739 18.4958 34.8003 18.3854 34.7075 18.2925ZM28 14.4138L31.5863 18H28V14.4138Z"
              fill="var(--color-secondary-orange-3)"
            />
          </svg>
        );
      }

      case "metricTotalVideosShared": {
        return (
          <svg
            width={width ?? "48"}
            height={height ?? "49"}
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="24"
              cy="24.5"
              r="24"
              fill="var(--color-secondary-bluegrey-2)"
            />
            <path
              d="M19.7074 17.7083L22.9999 14.4145V23.0008C22.9999 23.266 23.1053 23.5204 23.2928 23.7079C23.4804 23.8954 23.7347 24.0008 23.9999 24.0008C24.2652 24.0008 24.5195 23.8954 24.7071 23.7079C24.8946 23.5204 24.9999 23.266 24.9999 23.0008V14.4145L28.2924 17.7083C28.4801 17.8959 28.7346 18.0013 28.9999 18.0013C29.2653 18.0013 29.5198 17.8959 29.7074 17.7083C29.8951 17.5206 30.0005 17.2662 30.0005 17.0008C30.0005 16.7354 29.8951 16.4809 29.7074 16.2933L24.7074 11.2933C24.6146 11.2003 24.5043 11.1266 24.3829 11.0762C24.2615 11.0259 24.1314 11 23.9999 11C23.8685 11 23.7384 11.0259 23.617 11.0762C23.4956 11.1266 23.3853 11.2003 23.2924 11.2933L18.2924 16.2933C18.1048 16.4809 17.9994 16.7354 17.9994 17.0008C17.9994 17.2662 18.1048 17.5206 18.2924 17.7083C18.4801 17.8959 18.7346 18.0013 18.9999 18.0013C19.2653 18.0013 19.5198 17.8959 19.7074 17.7083Z"
              fill="var(--color-secondary-bluegrey-5)"
            />
            <path
              d="M34.4142 36.4142C34.7893 36.0391 35 35.5304 35 35V23C35 22.4696 34.7893 21.9609 34.4142 21.5858C34.0391 21.2107 33.5304 21 33 21H30C29.7348 21 29.4804 21.1054 29.2929 21.2929C29.1054 21.4804 29 21.7348 29 22C29 22.2652 29.1054 22.5196 29.2929 22.7071C29.4804 22.8946 29.7348 23 30 23H33V35H15V23H18C18.2652 23 18.5196 22.8946 18.7071 22.7071C18.8946 22.5196 19 22.2652 19 22C19 21.7348 18.8946 21.4804 18.7071 21.2929C18.5196 21.1054 18.2652 21 18 21H15C14.4696 21 13.9609 21.2107 13.5858 21.5858C13.2107 21.9609 13 22.4696 13 23V35C13 35.5304 13.2107 36.0391 13.5858 36.4142C13.9609 36.7893 14.4696 37 15 37H33C33.5304 37 34.0391 36.7893 34.4142 36.4142Z"
              fill="var(--color-secondary-bluegrey-5)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.555 28.1682L21.555 24.1682C21.4044 24.0677 21.2293 24.0099 21.0484 24.0012C20.8675 23.9924 20.6877 24.0329 20.528 24.1184C20.3684 24.2039 20.2349 24.3311 20.1419 24.4865C20.0489 24.6419 19.9999 24.8196 20 25.0007V33.0007C19.9999 33.1817 20.0489 33.3595 20.1419 33.5148C20.2349 33.6702 20.3684 33.7974 20.528 33.8829C20.6877 33.9684 20.8675 34.0089 21.0484 34.0001C21.2293 33.9914 21.4044 33.9337 21.555 33.8332L27.555 29.8332C27.6922 29.7419 27.8047 29.6181 27.8825 29.4729C27.9603 29.3276 28.001 29.1654 28.001 29.0007C28.001 28.8359 27.9603 28.6737 27.8825 28.5284C27.8047 28.3832 27.6922 28.2594 27.555 28.1682ZM22 31.1319V26.8757L25.1975 29.0007L22 31.1319Z"
              fill="var(--color-secondary-bluegrey-5)"
            />
          </svg>
        );
      }

      case "camera": {
        return (
          <svg
            width={width ?? "20"}
            height={height ?? "16"}
            viewBox="0 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.1481 2.46154H15L14.25 0.465934C14.1982 0.32938 14.1032 0.211345 13.9781 0.127951C13.853 0.0445569 13.7038 -0.000128048 13.5509 2.75611e-07H6.44907C6.13657 2.75611e-07 5.85648 0.186813 5.75231 0.465934L5 2.46154H1.85185C0.828704 2.46154 0 3.24835 0 4.21978V14.2418C0 15.2132 0.828704 16 1.85185 16H18.1481C19.1713 16 20 15.2132 20 14.2418V4.21978C20 3.24835 19.1713 2.46154 18.1481 2.46154ZM18.3333 14.2418C18.3333 14.3385 18.25 14.4176 18.1481 14.4176H1.85185C1.75 14.4176 1.66667 14.3385 1.66667 14.2418V4.21978C1.66667 4.12308 1.75 4.04396 1.85185 4.04396H6.17361L6.56944 2.99341L7.09954 1.58242H12.8981L13.4282 2.99341L13.8241 4.04396H18.1481C18.25 4.04396 18.3333 4.12308 18.3333 4.21978V14.2418ZM10 5.45055C7.9537 5.45055 6.2963 7.02418 6.2963 8.96703C6.2963 10.9099 7.9537 12.4835 10 12.4835C12.0463 12.4835 13.7037 10.9099 13.7037 8.96703C13.7037 7.02418 12.0463 5.45055 10 5.45055ZM10 11.0769C8.77315 11.0769 7.77778 10.1319 7.77778 8.96703C7.77778 7.8022 8.77315 6.85714 10 6.85714C11.2269 6.85714 12.2222 7.8022 12.2222 8.96703C12.2222 10.1319 11.2269 11.0769 10 11.0769Z"
              fill="var(--color-primary-black)"
            />
          </svg>
        );
      }

      case "juiscigpt-link": {
        return (
          <svg
            width={width ?? "19"}
            height={height ?? "24"}
            viewBox="0 0 19 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5923 10.3403C15.3119 10.3403 18.3139 13.2985 18.3139 16.9374C18.3139 18.1348 17.9791 19.2617 17.4169 20.236L17.704 21.3042L18.3139 23.5463L16.0296 22.9476L14.9412 22.6659C13.9485 23.2294 12.8123 23.5463 11.5804 23.5463C7.86079 23.5463 4.8588 20.5882 4.8588 16.9492C4.8588 13.3102 7.87275 10.3521 11.5804 10.3521L11.5923 10.3403Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.4874 9.89921C11.5216 9.89108 11.5568 9.88689 11.5924 9.88689C15.555 9.88689 18.7675 13.0406 18.7675 16.9375C18.7675 18.1525 18.4455 19.2972 17.9028 20.2965L18.1416 21.1852L18.142 21.1866L18.7516 23.4273C18.7941 23.5835 18.7501 23.7505 18.6362 23.8655C18.5222 23.9805 18.3556 24.0261 18.1991 23.985L15.916 23.3867L15.9147 23.3863L15.0021 23.1501C13.9816 23.6954 12.8254 23.9998 11.5805 23.9998C7.61792 23.9998 4.4054 20.8461 4.4054 16.9492C4.4054 13.0825 7.57989 9.94826 11.4874 9.89921ZM11.6804 10.7945C11.6479 10.8018 11.6144 10.8056 11.5805 10.8056C8.11526 10.8056 5.31237 13.5687 5.31237 16.9492C5.31237 20.3303 8.10383 23.0929 11.5805 23.0929C12.7326 23.0929 13.7918 22.7969 14.7174 22.2716C14.8198 22.2134 14.9409 22.1974 15.0549 22.2269L16.1446 22.509L17.6706 22.9089L17.2665 21.4233L17.2661 21.4219L16.9791 20.3537C16.9478 20.2375 16.9641 20.1137 17.0242 20.0094C17.5497 19.0986 17.8605 18.0492 17.8605 16.9375C17.8605 13.585 15.116 10.8406 11.6804 10.7945Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M8.73149 6.83838C7.97993 6.83838 7.23417 7.02512 6.56793 7.38708L6.55318 7.39495C4.40858 8.56003 2.65688 10.3042 1.48767 12.4403L1.47977 12.455C0.974165 13.3788 0.809317 14.4552 1.01577 15.487L1.4113 17.4647C1.47397 17.7784 1.41657 18.1015 1.24909 18.3748L0.979431 18.815C0.844077 19.0358 0.877784 19.3175 1.06159 19.5006C1.2454 19.6837 1.52822 19.7172 1.74995 19.5824L2.19183 19.3138C2.4657 19.147 2.79065 19.0898 3.1056 19.1523L5.09325 19.5467C6.12711 19.7518 7.20625 19.5887 8.13214 19.0872C8.13319 19.0867 8.13372 19.0862 8.13478 19.0856C10.2831 17.9211 12.0385 16.1753 13.2098 14.0366L13.2224 14.0135C13.728 13.0903 13.8934 12.0133 13.6869 10.9815L13.2919 9.00645C13.2293 8.69275 13.2867 8.36961 13.4541 8.09631L13.7238 7.65619C13.8592 7.43534 13.8254 7.15365 13.6416 6.97109C13.4578 6.78802 13.175 6.75444 12.9533 6.88926L12.5114 7.15784C12.2375 7.32466 11.9126 7.38184 11.5976 7.31941L9.61209 6.92546C9.32031 6.86723 9.02537 6.83838 8.73149 6.83838Z"
              fill="url(#paint0_linear_770_3817)"
            />
            <path
              d="M1.456 20.5563C1.08048 20.5563 0.709179 20.411 0.42741 20.1309C-0.0497534 19.6556 -0.137181 18.9233 0.214635 18.35L0.48429 17.9098C0.534324 17.8285 0.551178 17.7325 0.532744 17.6392L0.137215 15.6615C-0.109794 14.4256 0.0877076 13.1352 0.693379 12.0283L0.701279 12.0136C1.95317 9.72699 3.82865 7.85898 6.12388 6.61207L6.13862 6.6042C7.2499 6.00041 8.54551 5.80422 9.78634 6.05025L11.7719 6.4442C11.8656 6.46309 11.962 6.44578 12.0437 6.39594L12.4855 6.12683C13.0612 5.77642 13.7964 5.86402 14.2736 6.33876C14.7507 6.81403 14.8382 7.54633 14.4863 8.11969L14.2167 8.55981C14.1667 8.64112 14.1498 8.73712 14.1682 8.83049L14.5632 10.8055C14.8108 12.0419 14.6127 13.3324 14.0066 14.4393L13.9939 14.4623C12.7394 16.7526 10.8597 18.6217 8.55867 19.8686C8.55815 19.8691 8.55709 19.8697 8.55657 19.8697C7.4474 20.4698 6.15495 20.6649 4.91675 20.4194L2.92909 20.0249C2.83535 20.006 2.73897 20.0234 2.65733 20.0732L2.21546 20.3423C1.97951 20.4866 1.7167 20.5563 1.456 20.5563ZM8.73142 6.83868C7.97986 6.83868 7.2341 7.02543 6.56786 7.38739L6.55311 7.39526C4.40851 8.56034 2.65681 10.3046 1.4876 12.4406L1.4797 12.4553C0.974094 13.3791 0.809246 14.4555 1.0157 15.4874L1.41123 17.465C1.4739 17.7787 1.4165 18.1018 1.24902 18.3751L0.979361 18.8153C0.844006 19.0361 0.877713 19.3178 1.06152 19.5009C1.24533 19.684 1.52815 19.7175 1.74988 19.5827L2.19176 19.3141C2.46562 19.1473 2.79058 19.0901 3.10553 19.1526L5.09318 19.547C6.12704 19.7522 7.20618 19.589 8.13207 19.0875C8.13312 19.087 8.13365 19.0865 8.1347 19.0859C10.283 17.9214 12.0384 16.1756 13.2097 14.0369L13.2223 14.0138C13.7279 13.0906 13.8933 12.0136 13.6869 10.9818L13.2919 9.00675C13.2292 8.69306 13.2866 8.36992 13.4541 8.09661L13.7237 7.6565C13.8591 7.43565 13.8254 7.15395 13.6416 6.9714C13.4578 6.78832 13.1749 6.75475 12.9532 6.88957L12.5113 7.15815C12.2375 7.32496 11.9125 7.38214 11.5976 7.31972L9.61201 6.92576C9.32024 6.86753 9.0253 6.83868 8.73142 6.83868Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M4.67808 11.0107C4.5638 11.0107 4.44951 10.9672 4.36208 10.8806C4.1867 10.707 4.18617 10.4248 4.3605 10.2501C5.15999 9.45012 6.07587 8.76817 7.08233 8.22261L7.09392 8.21632C7.64798 7.91573 8.26945 7.75836 8.89461 7.75836C9.14267 7.75836 9.3902 7.78302 9.63036 7.83128C9.87263 7.88006 10.0291 8.1156 9.98007 8.3569C9.93109 8.59821 9.69514 8.75453 9.45235 8.70522C9.27065 8.6685 9.08315 8.65014 8.89461 8.65014C8.4185 8.65014 7.94502 8.77027 7.52579 8.99793L7.5142 9.00423C6.58042 9.51044 5.73406 10.141 4.99566 10.8796C4.90824 10.9667 4.7929 11.0107 4.67808 11.0107Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M6.81193 18.3359C6.65288 18.3359 6.50857 18.2257 6.47328 18.0647C6.45379 17.9745 6.47012 17.8821 6.52016 17.8045C6.57019 17.7269 6.64761 17.6734 6.7382 17.6534C6.82878 17.634 6.92148 17.6503 6.9989 17.7001C7.07685 17.7499 7.13057 17.8271 7.15058 17.9173C7.19113 18.1035 7.07211 18.2876 6.88566 18.328C6.86091 18.3333 6.83616 18.3359 6.81193 18.3359Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M6.53121 17.0541C6.46538 17.0541 6.40113 17.0352 6.34425 16.999C6.2663 16.9492 6.21258 16.872 6.19309 16.7823C6.15254 16.5966 6.27104 16.4125 6.45695 16.3716C6.54859 16.3517 6.64129 16.3684 6.71923 16.4183C6.79718 16.4681 6.8509 16.5452 6.87039 16.6355C6.88988 16.7257 6.87355 16.818 6.82352 16.8956C6.77348 16.9733 6.69606 17.0268 6.60547 17.0467C6.58072 17.0514 6.55597 17.0541 6.53121 17.0541Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M7.91267 16.6918C7.84736 16.6918 7.78311 16.6735 7.72675 16.6373C7.64881 16.5874 7.59456 16.5103 7.57507 16.4201C7.55559 16.3299 7.57191 16.2375 7.62195 16.1599C7.67198 16.0823 7.7494 16.0288 7.83999 16.0088C7.93058 15.9889 8.02327 16.0057 8.10122 16.0555C8.17916 16.1053 8.23288 16.1825 8.25237 16.2727C8.27186 16.3629 8.25553 16.4552 8.2055 16.5329C8.15546 16.6105 8.07804 16.664 7.98746 16.6834C7.96218 16.6892 7.93742 16.6918 7.91267 16.6918Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M5.12263 17.2981C5.0568 17.2981 4.99254 17.2792 4.93619 17.2431C4.85824 17.1932 4.80452 17.1161 4.78503 17.0259C4.76555 16.9357 4.78187 16.8433 4.83191 16.7657C4.88194 16.6881 4.95936 16.6345 5.04995 16.6151C5.13948 16.5952 5.23218 16.612 5.31012 16.6613C5.38807 16.7111 5.44232 16.7882 5.46233 16.8779C5.50289 17.0647 5.38439 17.2488 5.19742 17.2892C5.17266 17.2955 5.14738 17.2981 5.12263 17.2981Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M11.6372 10.4051C12.0153 10.4051 12.3218 10.2759 12.3218 10.1166C12.3218 9.95725 12.0153 9.82808 11.6372 9.82808C11.259 9.82808 10.9525 9.95725 10.9525 10.1166C10.9525 10.2759 11.259 10.4051 11.6372 10.4051Z"
              fill="var(--color-primary-black)"
            />
            <path
              d="M11.637 10.2474C11.39 10.2474 11.1893 10.0476 11.1893 9.80155V2.51363C11.1893 2.3956 11.2367 2.28177 11.3204 2.19836L13.3966 0.130482C13.5714 -0.0436771 13.8548 -0.0436771 14.0296 0.130482C14.2045 0.304641 14.2045 0.586863 14.0296 0.761022L12.0846 2.69828V9.80155C12.0846 10.0481 11.884 10.2474 11.637 10.2474Z"
              fill="var(--color-primary-black)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_770_3817"
                x1="7.35162"
                y1="6.80705"
                x2="7.35162"
                y2="19.6646"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFD000" />
                <stop offset="1" stopColor="#FFA100" />
              </linearGradient>
            </defs>
          </svg>
        );
      }

      case "videoPublication": {
        return (
          <svg
            width={width ?? "22"}
            height={height ?? "18"}
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.5625 17.125C21.5625 17.3405 21.4769 17.5472 21.3245 17.6995C21.1722 17.8519 20.9655 17.9375 20.75 17.9375H1.25C1.03451 17.9375 0.827849 17.8519 0.675476 17.6995C0.523102 17.5472 0.4375 17.3405 0.4375 17.125C0.4375 16.9095 0.523102 16.7028 0.675476 16.5505C0.827849 16.3981 1.03451 16.3125 1.25 16.3125H20.75C20.9655 16.3125 21.1722 16.3981 21.3245 16.5505C21.4769 16.7028 21.5625 16.9095 21.5625 17.125ZM21.5625 1.6875V13.0625C21.5625 13.4935 21.3913 13.9068 21.0865 14.2115C20.7818 14.5163 20.3685 14.6875 19.9375 14.6875H2.0625C1.63152 14.6875 1.2182 14.5163 0.913451 14.2115C0.608705 13.9068 0.4375 13.4935 0.4375 13.0625V1.6875C0.4375 1.25652 0.608705 0.843198 0.913451 0.538451C1.2182 0.233705 1.63152 0.0625 2.0625 0.0625H19.9375C20.3685 0.0625 20.7818 0.233705 21.0865 0.538451C21.3913 0.843198 21.5625 1.25652 21.5625 1.6875ZM14.6562 7.375C14.6562 7.23825 14.6217 7.10373 14.5558 6.98389C14.4899 6.86406 14.3949 6.76278 14.2795 6.68945L9.8107 3.8457C9.68787 3.76767 9.54634 3.72405 9.40089 3.71941C9.25544 3.71478 9.11141 3.74929 8.98386 3.81934C8.85631 3.8894 8.74992 3.99242 8.67579 4.11766C8.60167 4.24289 8.56254 4.38573 8.5625 4.53125V10.2188C8.56254 10.3643 8.60167 10.5071 8.67579 10.6323C8.74992 10.7576 8.85631 10.8606 8.98386 10.9307C9.11141 11.0007 9.25544 11.0352 9.40089 11.0306C9.54634 11.0259 9.68787 10.9823 9.8107 10.9043L14.2795 8.06055C14.3949 7.98722 14.4899 7.88594 14.5558 7.76611C14.6217 7.64627 14.6562 7.51175 14.6562 7.375Z"
              fill="white"
            />
          </svg>
        );
      }

      case "cookies": {
        return (
          <svg
            width={width ?? "17"}
            height={height ?? "17"}
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.625 7.5C14.7962 7.5 14.0013 7.17076 13.4153 6.58471C12.8292 5.99866 12.5 5.2038 12.5 4.375C12.5 4.20924 12.4342 4.05027 12.3169 3.93306C12.1997 3.81585 12.0408 3.75 11.875 3.75C11.0462 3.75 10.2513 3.42076 9.66529 2.83471C9.07924 2.24866 8.75 1.4538 8.75 0.625C8.75 0.45924 8.68416 0.300268 8.56695 0.183058C8.44974 0.065848 8.29076 0 8.125 0C6.51803 0 4.94714 0.476523 3.611 1.36931C2.27485 2.2621 1.23344 3.53105 0.618482 5.0157C0.00352044 6.50035 -0.157382 8.13401 0.156123 9.71011C0.469628 11.2862 1.24346 12.7339 2.37976 13.8702C3.51606 15.0065 4.9638 15.7804 6.5399 16.0939C8.11599 16.4074 9.74966 16.2465 11.2343 15.6315C12.719 15.0166 13.9879 13.9752 14.8807 12.639C15.7735 11.3029 16.25 9.73197 16.25 8.125C16.25 7.95924 16.1842 7.80027 16.0669 7.68306C15.9497 7.56585 15.7908 7.5 15.625 7.5ZM4.02422 5.89922C4.15546 5.76843 4.32252 5.67947 4.50428 5.64356C4.68605 5.60765 4.87438 5.6264 5.0455 5.69746C5.21662 5.76851 5.36284 5.88867 5.46571 6.04277C5.56858 6.19687 5.62348 6.378 5.62348 6.56328C5.62348 6.74856 5.56858 6.92969 5.46571 7.08379C5.36284 7.23789 5.21662 7.35805 5.0455 7.42911C4.87438 7.50016 4.68605 7.51891 4.50428 7.48301C4.32252 7.44709 4.15546 7.35813 4.02422 7.22734C3.93682 7.14025 3.86748 7.03675 3.82016 6.9228C3.77284 6.80884 3.74848 6.68667 3.74848 6.56328C3.74848 6.43989 3.77284 6.31772 3.82016 6.20376C3.86748 6.08981 3.93682 5.98632 4.02422 5.89922ZM5.97735 11.6023C5.84611 11.7331 5.67905 11.8221 5.49729 11.858C5.31552 11.8939 5.12718 11.8752 4.95607 11.8041C4.78495 11.7331 4.63873 11.6129 4.53586 11.4588C4.43299 11.3047 4.37809 11.1236 4.37809 10.9383C4.37809 10.753 4.43299 10.5719 4.53586 10.4178C4.63873 10.2637 4.78495 10.1435 4.95607 10.0725C5.12718 10.0014 5.31552 9.98265 5.49729 10.0186C5.67905 10.0545 5.84611 10.1434 5.97735 10.2742C6.06441 10.3614 6.13344 10.4649 6.18048 10.5787C6.22753 10.6926 6.25167 10.8146 6.25152 10.9378C6.25138 11.061 6.22695 11.183 6.17964 11.2967C6.13232 11.4105 6.06305 11.5138 5.97578 11.6008L5.97735 11.6023ZM7.77422 8.47734C7.64344 8.3461 7.55447 8.17905 7.51856 7.99728C7.48265 7.81551 7.50141 7.62718 7.57246 7.45607C7.64351 7.28495 7.76368 7.13872 7.91778 7.03585C8.07188 6.93298 8.253 6.87808 8.43828 6.87808C8.62357 6.87808 8.80469 6.93298 8.95879 7.03585C9.11289 7.13872 9.23306 7.28495 9.30411 7.45607C9.37516 7.62718 9.39392 7.81551 9.35801 7.99728C9.3221 8.17905 9.23313 8.3461 9.10235 8.47734C9.01515 8.56464 8.91157 8.63387 8.79756 8.68105C8.68355 8.72823 8.56135 8.75245 8.43796 8.7523C8.31457 8.75216 8.19243 8.72766 8.07853 8.6802C7.96463 8.63275 7.86122 8.56328 7.77422 8.47578V8.47734ZM10.9773 12.2273C10.8461 12.3581 10.6791 12.4471 10.4973 12.483C10.3155 12.5189 10.1272 12.5002 9.95607 12.4291C9.78495 12.3581 9.63873 12.2379 9.53586 12.0838C9.43299 11.9297 9.37809 11.7486 9.37809 11.5633C9.37809 11.378 9.43299 11.1969 9.53586 11.0428C9.63873 10.8887 9.78495 10.7685 9.95607 10.6975C10.1272 10.6264 10.3155 10.6076 10.4973 10.6436C10.6791 10.6795 10.8461 10.7684 10.9773 10.8992C11.0644 10.9864 11.1334 11.0899 11.1805 11.2037C11.2275 11.3176 11.2517 11.4396 11.2515 11.5628C11.2514 11.686 11.2269 11.808 11.1796 11.9217C11.1323 12.0355 11.0631 12.1388 10.9758 12.2258L10.9773 12.2273Z"
              fill="var(--color-primary-black)"
            />
          </svg>
        );
      }

      case "info": {
        return (
          <svg
            width={width ?? "26"}
            height={height ?? "26"}
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 0C10.4288 0 7.91543 0.762437 5.77759 2.1909C3.63975 3.61935 1.97351 5.64968 0.989572 8.02512C0.0056327 10.4006 -0.251811 13.0144 0.249797 15.5362C0.751405 18.0579 1.98953 20.3743 3.80762 22.1924C5.6257 24.0105 7.94208 25.2486 10.4638 25.7502C12.9856 26.2518 15.5995 25.9944 17.9749 25.0104C20.3503 24.0265 22.3807 22.3603 23.8091 20.2224C25.2376 18.0846 26 15.5712 26 13C25.9964 9.5533 24.6256 6.24882 22.1884 3.81163C19.7512 1.37445 16.4467 0.00363977 13 0ZM12.5 6C12.7967 6 13.0867 6.08797 13.3334 6.2528C13.58 6.41762 13.7723 6.65189 13.8858 6.92597C13.9994 7.20006 14.0291 7.50166 13.9712 7.79264C13.9133 8.08361 13.7704 8.35088 13.5607 8.56066C13.3509 8.77044 13.0836 8.9133 12.7926 8.97118C12.5017 9.02906 12.2001 8.99935 11.926 8.88582C11.6519 8.77229 11.4176 8.58003 11.2528 8.33335C11.088 8.08668 11 7.79667 11 7.5C11 7.10218 11.158 6.72064 11.4393 6.43934C11.7206 6.15804 12.1022 6 12.5 6ZM14 20C13.4696 20 12.9609 19.7893 12.5858 19.4142C12.2107 19.0391 12 18.5304 12 18V13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11C12.5304 11 13.0391 11.2107 13.4142 11.5858C13.7893 11.9609 14 12.4696 14 13V18C14.2652 18 14.5196 18.1054 14.7071 18.2929C14.8946 18.4804 15 18.7348 15 19C15 19.2652 14.8946 19.5196 14.7071 19.7071C14.5196 19.8946 14.2652 20 14 20Z"
              fill="var(--color-secondary-bluegrey-7)"
            />
          </svg>
        );
      }

      case "editorial": {
        return (
          <svg
            width={width ?? "56"}
            height={height ?? "56"}
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="28" cy="28" r="28" fill="var(--color-primary-black)" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.5988 34.0923C12.5988 33.557 13.0327 33.1231 13.568 33.1231H29.0757C29.611 33.1231 30.0449 33.557 30.0449 34.0923C30.0449 34.6276 29.611 35.0616 29.0757 35.0616H14.5372V35.2C14.5372 37.1118 16.087 38.6616 17.9988 38.6616H33.5645C34.0998 38.6616 34.5337 39.0955 34.5337 39.6308C34.5337 40.1661 34.0998 40.6 33.5645 40.6H17.9988C15.0164 40.6 12.5988 38.1824 12.5988 35.2V34.0923Z"
              fill="white"
            />
            <path
              d="M16.7086 39.2416C14.0779 38.5839 13.4202 35.6791 13.4202 34.3089H29.0404C29.0404 37.5974 29.8625 37.5974 31.5068 39.2416C27.6702 39.5156 19.3394 39.8993 16.7086 39.2416Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.6761 21.9079C23.6761 21.3726 24.1101 20.9387 24.6454 20.9387H32.3992C32.9345 20.9387 33.3685 21.3726 33.3685 21.9079C33.3685 22.4432 32.9345 22.8771 32.3992 22.8771H24.6454C24.1101 22.8771 23.6761 22.4432 23.6761 21.9079Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.6761 27.4463C23.6761 26.9111 24.1101 26.4771 24.6454 26.4771H32.3992C32.9345 26.4771 33.3685 26.9111 33.3685 27.4463C33.3685 27.9816 32.9345 28.4156 32.3992 28.4156H24.6454C24.1101 28.4156 23.6761 27.9816 23.6761 27.4463Z"
              fill="white"
            />
            <path
              d="M44.5791 33.7219L47.6804 31.5676L35.693 28.5539L42.0143 39.5063L43.1411 35.7907L46.8115 38.5075C47.3429 38.9303 47.3464 38.8774 47.6855 38.3772L48.4547 37.3582C48.8466 36.8615 48.8867 36.8723 48.3372 36.4769L44.5791 33.7219Z"
              fill="white"
            />
            <path
              d="M35.7216 15.4001C37.4798 15.4003 38.9061 16.8265 38.9061 18.5847V26.8181L36.9677 26.3308V18.5847C36.9676 17.8971 36.4092 17.3388 35.7216 17.3386H21.3212C20.6334 17.3386 20.0751 17.897 20.0751 18.5847V33.1228H29.0751C29.6104 33.1228 30.0438 33.5572 30.0438 34.0925V35.2C30.0438 37.1117 31.594 38.6618 33.5057 38.6619C35.2663 38.6619 36.7184 37.3472 36.9374 35.6462L38.2098 37.8503C37.2833 39.4914 35.5247 40.6003 33.5057 40.6003C30.5234 40.6003 28.1053 38.1823 28.1053 35.2V35.0613H19.1053C18.5703 35.061 18.1366 34.6276 18.1366 34.0925V18.5847C18.1366 16.8264 19.5628 15.4002 21.3212 15.4001H35.7216ZM38.9061 29.3621V34.1238L36.9677 30.7654V28.8748L38.9061 29.3621Z"
              fill="white"
            />
          </svg>
        );
      }

      default: {
        return null;
      }
    }
  }

  override render() {
    return (
      <div
        className={`--custom-icon cursor-pointer ${this.props.className ?? ""}`}
        style={{
          ...this.props.style,
          transform: `scale(${this.props.scale ?? 1})`,
        }}
        onClick={this.props.onClick}
        onTouchStart={this.props.onTouchStart}
      >
        {this.renderIcon(
          this.props.iconName,
          this.props.color,
          this.props.color2,
          this.props.increase,
          this.props.width,
          this.props.height
        )}
      </div>
    );
  }
}

export default CustomIcon;
